const Strings = Object.freeze({
  PORTUGUESE: "Português",
  ENGLISH: "English",
  SPANISH: "Español",
  DATE_LOCALE: "pt-BR",
  CURRENT_VALUE_DP: "Valor atual: ",
  MILLISECONDS_SUFFIX: " ms",
  KILOBITS_PER_SECOND_SUFFIX: " Kbps",
  MEGABITS_PER_SECOND_SUFFIX: " Mbps",
  TENDENCY_AND: " e ",
  TS_MONITOR_LOGO_ALT: "Logotipo do TS Monitor",
  TENDENCY_GOOD_PING_LIMIT: "< 16 ms",
  TENDENCY_WARNING_PING_LIMIT: "≥ 16 ms",
  TENDENCY_WARNING_UPPER_PING_LIMIT: "< 26 ms",
  TENDENCY_BAD_PING_LIMIT: "> 26 ms",
  NETWORK_IP_PLACEHOLDER: "192.168.0.2",
  NETWORK_MASK_PLACEHOLDER: "255.255.255.0",
  NETWORK_GATEWAY_PLACEHOLDER: "192.168.0.1",
  DHCP_PLACEHOLDER: "DHCP",
  SWEEP_FIRST_BAND_PLACEHOLDER: "192.168.2",
  SWEEP_SECOND_BAND_PLACEHOLDER: "192.168.3",
  SWEEP_THIRD_BAND_PLACEHOLDER: "192.168.4",
  SWEEP_FOURTH_BAND_PLACEHOLDER: "192.168.5",
  SWEEP_FIFTH_BAND_PLACEHOLDER: "192.168.6",
  SWEEP_BEGINNING_PLACEHOLDER: "0",
  SWEEP_END_PLACEHOLDER: "255",
  PING_LIMIT_PLACEHOLDER: "200",
  PACKET_LOSS_RATE_PLACEHOLDER: "42",
  MILLISECONDS_UNIT: "ms",
  PERCENTAGE_UNIT: "%",


  //  ---------------------------- Live List ----------------------------
  CONFIG_METHOD_1: "Método de",
  CONFIG_METHOD_2: "configuração",
  LOST_PACKET_PERC_1: "Pings",
  LOST_PACKET_PERC_2: "Perdidos (%)",
  TENDENCY: "Tendência",
  AVAILABILITY: "Disponibilidade",
  STATUS: "Status",

  OFFLINE_STRING: "Offline",
  ONLINE_STRING: "Online",
  FAULT_STRING: "Falha",

  LIVE_LIST_OK_POPUP_TEXT: "Dispositivo EtherNet/IP em operação normal, ou seja, em troca de dados.",
  LIVE_LIST_FAULT_POPUP_TEXT: "Dispositivo EtherNet/IP que esteve em modo de operação normal (OK), mas não está mais comunicando na rede.",
  LIVE_LIST_ONLINE_POPUP_TEXT: "Dispositivo ativo na rede que não troca dados do protocolo EtherNet/IP.",
  LIVE_LIST_OFFLINE_POPUP_TEXT: "Dispositivo não EtherNet/IP que esteve ativo na rede (Online), mas que não é mais acessível pelo monitor.",

  ETHERNET_IP: "EtherNet/IP",

  INSUFFICIENT_DATA: "Sem dados suficientes",


  EXPORT_CSV: "Exportar XLSX",

  IP_POPUP_1: "A célula IP de um dispositivo terá fundo roxo caso seu IP estiver duplicado, como no exemplo abaixo.",
  IP_POPUP_2: "Caso o dispositivo perca seu endereço IP, ele terá fundo laranja, como no exemplo abaixo.",
  IP_POPUP_3: "Além disso, ao clicar na célula é possível excluir o dispositivo, caso queira.",

  CONFIG_METHOD_POPUP_1: "Determina como o dispositivo deverá obter suas configurações de IP.",

  CONFIG_METHOD_POPUP_2: "O Valor (0) indica que o dispositivo deverá obter suas configurações de IP estaticamente.",
  CONFIG_METHOD_POPUP_3: "O Valor (1) indica que o dispositivo deverá obter suas configurações de IP via BOOTP.",
  CONFIG_METHOD_POPUP_4: "O Valor (2) indica que o dispositivo deverá obter suas configurações de IP via DHCP.",
  CONFIG_METHOD_POPUP_5: "Os valores (3-15) são reservados para uso futuro.",

  CONFIG_METHOD_POPUP_6: "Caso o método seja DHCP, a célula ficará como no exemplo abaixo.",

  MISSED_PINGS_POPUP: "Quantidade / % de pings perdidos nos últimos 360 pings realizados.",

  NETWORK_AVAILABILITY_DP: "Disponibilidade da rede: ",

  LIVE_LIST_CSV_HEADER: "IP,MAC,Protocolo,Método de configuração,Ping atual (ms),Ping médio (ms),Pings perdidos,Pings perdidos (%),Disponibilidade,Status\n",
  LIVE_LIST_CSV_EXPORT_NAME: "Live List.xlsx",
  TENDENCY_POPUP_1: "A barra de tendência é dividida em 9 partes, cada uma delas compreende uma porção das últimas 360 respostas de ping (no máximo).",
  TENDENCY_POPUP_2: "Somente são levados em consideração os pings de pacotes que não foram perdidos.",
  TENDENCY_POPUP_3: "• Se todos os pings da parte forem ",
  TENDENCY_POPUP_4: " ela será pintada de verde.",
  TENDENCY_POPUP_5: "• Se algum ping da parte for ",
  TENDENCY_POPUP_6: " ela será pintada de amarelo.",
  TENDENCY_POPUP_7: "• Se algum ping da parte for ",
  TENDENCY_POPUP_8: " ela será pintada de vermelho.",

  // ---------------------------- Inventory ----------------------------
  PRODUCT_NAME_POPUP_1: "É uma breve descrição do produto, que é representado pelo product code.",
  PRODUCT_NAME_POPUP_2: "Um mesmo product code pode ter uma variedade de nomes do produto.",
  PRODUCT_NAME_POPUP_3: "O número máximo de caracteres para um nome do produto é 32.",

  VENDOR_ID_POPUP_1: "Os valores de 'Vendor ID' são gerenciados pela ODVA.",
  VENDOR_ID_POPUP_2: "O valor zero (0) não é considerado válido.",

  REVISION_POPUP_1: "A revisão consiste de dois valores: Major e Minor.",
  REVISION_POPUP_2: "Os valores Major e Minor são tipicamente apresentados como major.minor (e.x.: 3.15).",

  PRODUCT_CODE_1: "O Product Code atribuído pelo vendedor identifica um produto particular entre um tipo de dispositivo.",
  PRODUCT_CODE_2: "Cada vendedor atribui esse código a cada um de seus produtos. Ele é tipicamente mapeado a um ou mais números de catálogo / modelos.",
  PRODUCT_CODE_3: "Os produtos devem ter códigos diferentes se sua configuração e / ou opções de tempo de execução forem diferentes.",
  PRODUCT_CODE_4: "O valor zero não é válido.",

  SERIAL_NUMBER_POPUP_1: "O serial number é usado em conjunto com o Vendor ID para formar um identificador único para cada dispositivo da rede.",
  SERIAL_NUMBER_POPUP_2: "Cada fornecedor / fabricante é responsável por garantir a exclusividade do serial number em todos os seus dispositivos.",
  SERIAL_NUMBER_POPUP_3: "Zero (0) não é um valor válido de serial number e não deve ser atribuído a nenhum produto, ou reportado por qualquer dispositivo.",
  SERIAL_NUMBER_POPUP_4: "A recepção do valor zero (0) ao acessar este atributo indica que o dispositivo não possui um serial number.",

  DEVICE_TYPE_POPUP_1: "O valor tipo de dispositivo é usado para identificar o device profile que o produto está utilizando.",
  DEVICE_TYPE_POPUP_2: "Os profiles definem os requisitos mínimos que o dispositivo deve implementar, bem como opções comuns.",
  DEVICE_TYPE_POPUP_3: "A lista pública de device profiles é gerenciada pela ODVA.",

  NUM_OF_DEVICES: "Quantidade de dispositivos encontrados: ",

  INVENTORY_CSV_EXPORT_NAME: "Inventário.xlsx",
  INVENTORY_CSV_HEADER: "IP,MAC,Nome do produto,Vendor ID,Revisão,Product Code,Serial Number,Tipo de dispositivo\n",

  //  ---------------------------- PORTS ----------------------------
  PRODUCT_NAME_1: "Nome",
  PRODUCT_NAME_2: "do",
  PRODUCT_NAME_3: "produto",

  INTERFACE_TYPE_1: "Tipo de",
  INTERFACE_TYPE_2: "interface",

  DUPLEX_MODE_1: "Modo",
  DUPLEX_MODE_2: "Duplex",

  INTERFACE_SPEED_1: "Velocidade",
  INTERFACE_SPEED_2: "da interface",

  NEGOTIATION_STATUS_1: "Status de",
  NEGOTIATION_STATUS_2: "negociação",

  HARDWARE_FAULT_1: "Falha de",
  HARDWARE_FAULT_2: "hardware local",

  INTERFACE_STATUS_1: "Estado da",
  INTERFACE_STATUS_2: "interface",

  LINK_STATUS_1: "Status",
  LINK_STATUS_2: "do link",

  INTERFACE_TYPE_POPUP_1: "O valor (0) indica que o tipo de interface é desconhecido.",
  INTERFACE_TYPE_POPUP_2: "O valor (1) indica que a interface é interna ao dispositivo.",
  INTERFACE_TYPE_POPUP_3: "O valor (2) indica que a interface é de par trançado (e.x., 10Base-T, 100Base-TX, 1000Base-T, etc.).",
  INTERFACE_TYPE_POPUP_4: "O valor (3) indica que a interface é de fibra óptica (e.x., 100Base-FX).",
  INTERFACE_TYPE_POPUP_5: "Os valores (4-256) são reservados.",
  INTERFACE_TYPE_POPUP_6: "Quando o valor for 'Sem resposta' quer dizer que não foi possível determinar o tipo de interface.",

  DUPLEX_MODE_POPUP_1: "O valor (0) indica que a porta está em modo half duplex.",
  DUPLEX_MODE_POPUP_2: "O valor (1) indica que a porta está em modo full duplex.",
  DUPLEX_MODE_POPUP_3: "Se o status do link for inativo ou desconhecido, então o modo duplex é indeterminado.",

  INTERFACE_SPEED_POPUP_1: "Indica a velocidade em que a interface está rodando.",
  INTERFACE_SPEED_POPUP_2: "O valor (0) indica que a velocidade da interface não pode ser determinada.",
  INTERFACE_SPEED_POPUP_3: "A velocidade da interface tem como objetivo representar a largura de banda; o atributo não é duplicado se a interface estiver em modo full-duplex.",

  NEGOTIATION_STATUS_POPUP_1: "O valor (0) indica que a auto negociação está em progresso.",
  NEGOTIATION_STATUS_POPUP_2: "O valor (1) indica que a auto negociação e a detecção de velocidade falharam. Valores padrões para velocidade e modo duplex estão sendo utilizados. Esses valores são específicos de cada produto (10 Mbps e half duplex são recomendados).",
  NEGOTIATION_STATUS_POPUP_3: "O valor (2) indica que a auto negociação falhou, mas a velocidade foi detectada. Um valor padrão para o modo duplex foi escolhido. Esse valor é específico de cada produto (half duplex é recomendado).",
  NEGOTIATION_STATUS_POPUP_4: "O valor (3) indica que a velocidade e o modo duplex foram negociados com sucesso.",
  NEGOTIATION_STATUS_POPUP_5: "O valor (4) indica que a autonegociação não foi tentada. Valores padrões de velocidade e modo duplex foram forçados.",

  LOCAL_HARDWARE_FAULT_POPUP_1: "O valor (0) indica que nesta porta não foi detectada nenhuma falha de hardware local.",
  LOCAL_HARDWARE_FAULT_POPUP_2: "O valor (1) indica que uma falha de hardware local foi detectada. Esse valor possui um significado específico para cada produto, mas é assumido que este tipo de erro requer algum tipo de intervenção do usuário para ser corrigido.",

  INTERFACE_STATUS_POPUP_1: "O valor (0) indica que o estado da interface é desconhecido.",
  INTERFACE_STATUS_POPUP_2: "O valor (1) indica que a interface está habilitada e pronta para enviar e receber dados.",
  INTERFACE_STATUS_POPUP_3: "O valor (2) indica que a interface está desabilitada.",
  INTERFACE_STATUS_POPUP_4: "O valor (3) indica que a interface está em teste.",
  INTERFACE_STATUS_POPUP_5: "Os valores (4-256) são reservados.",
  INTERFACE_STATUS_POPUP_6: "Quando o valor for 'Sem resposta' quer dizer que não foi possível determinar o estado da interface.",

  LINK_STATUS_POPUP_1: "Indica se a interface de comunicação está conectada a uma rede ativa. A determinação do status do link é específica de cada implementação.",
  LINK_STATUS_POPUP_2: "Em alguns casos, o dispositivo poder dizer se o link está ativo via suporte do hardware / driver.",
  LINK_STATUS_POPUP_3: "Em outros casos, o dispositivo pode apenas ser capaz de dizer se o link está ativo pela presença de pacotes de entrada.",

  PORTS_FILTER_LABEL: "Filtro de portas",
  PORTS_FILTER_POPUP_1: "Alguns dispositivos apresentam perdas de pacote em portas internas para as quais não há ação corretiva possível pelo usuário, e não trazem informação relevante para análise da rede em si.",
  PORTS_FILTER_POPUP_2: "O filtro elimina estas portas, porém, portas com nomes incomuns podem ser eliminadas e, por este motivo, o filtro pode ser desligado a fim de permitir a visualização completa.",

  ARE_YOU_SURE_YOU_WANT: "Tem certeza que deseja ",
  THE_PORTS_FILTER: " o filtro de portas?",

  TURN_ON: "ligar",
  TURN_OFF: "desligar",

  PORTS_FILTER_TURN_ON_FAILURE: "Ocorreu um erro ao ligar o filtro de portas.",
  PORTS_FILTER_TURN_OFF_FAILURE: "Ocorreu um erro ao desligar o filtro de portas.",

  SHOW_ONLY_ERROR_DEVICES: "Mostrar apenas dispositivos com erros",

  //  ---------------------------- NETWORK ----------------------------
  NETWORK_TOPOLOGY_1: "Topologia",
  NETWORK_TOPOLOGY_2: "da",
  NETWORK_TOPOLOGY_3: "rede",

  NETWORK_STATUS_1: "Status",
  NETWORK_STATUS_2: "da",
  NETWORK_STATUS_3: "rede",

  ADDRESS_CONFLICT_DETECTION: "Address Conflict Detection",
  RING_CAPABILITY_FLAGS: "Ring Capability Flags",

  ACD_CAPABLE_1: "ACD",
  ACD_CAPABLE_2: "capable",

  ACD_STATUS_1: "ACD",
  ACD_STATUS_2: "status",

  ANNOUNCE_BASED_RING_NODE_1: "Announce-based",
  ANNOUNCE_BASED_RING_NODE_2: "Ring Node",

  BEACON_BASED_RING_NODE_1: "Beacon-based",
  BEACON_BASED_RING_NODE_2: "Ring Node",

  FLUSH_TABLE_CAPABLE_1: "Flush Table",
  FLUSH_TABLE_CAPABLE_2: "Frame Capable",

  REDUNDANT_GATEWAY_CAPABLE_1: "Redundant Gateway",
  REDUNDANT_GATEWAY_CAPABLE_2: "Capable",

  SUPERVISOR_CAPABLE_1: "Supervisor",
  SUPERVISOR_CAPABLE_2: "Capable",

  NETWORK_TOPOLOGY_POPUP_1: "Modo atual da topologia da rede.",
  NETWORK_TOPOLOGY_POPUP_2: "O valor (0) indica que a topologia é Linear.",
  NETWORK_TOPOLOGY_POPUP_3: "O valor (1) indica que a topologia é em Anel (Ring).",
  NETWORK_TOPOLOGY_POPUP_4: "O valor 'Sem resposta' indica que não foi possível determinar a topologia da rede.",

  NETWORK_STATUS_POPUP_1: "Indica o status atual da rede com base na visão que o dispositivo tem da rede.",
  NETWORK_STATUS_POPUP_2: "O valor (0 - Normal) indica que a rede está operando normalmente, tanto no modo Anel (Ring) quanto no modo Linear.",
  NETWORK_STATUS_POPUP_3: "O valor (1 - Ring Fault) indica que uma falha de anel foi detectada. Este valor só é valido quando a topologia da rede for em Anel.",
  NETWORK_STATUS_POPUP_4: "O valor (2 - Unexpected Loop Detected) indica que um loop foi detectado na rede. Este valor só é valido quando a topologia da rede for Linear.",
  NETWORK_STATUS_POPUP_5: "O valor (3 - Partial Network Fault) indica que uma falha de rede foi detectada em uma direção apenas. Este valor é valido apenas quando a topologia da rede for em Anel e o nó que reporta é o ring supervisor ativo.",
  NETWORK_STATUS_POPUP_6: "O valor (4 - Rapid Fault/Restore Cycle) indica que uma série de rápidos ciclos de ring fault/restore foi detectada. Este valor é valido apenas para o DLR Supervisor.",
  NETWORK_STATUS_POPUP_7: "O valor 'Sem resposta' indica que não foi possível determinar o status atual da rede.",

  ACD_CAPABLE_POPUP_1: "O valor 'Sim' indica que o dispositivo é capaz de detectar conflitos de endereço.",
  ACD_CAPABLE_POPUP_2: "O valor 'Não' indica que o dispositivo não é capaz de detectar conflitos de endereço.",

  ACD_STATUS_POPUP_1: "Indica quando um conflito de endereço IP for detectado pelo ACD.",
  ACD_STATUS_POPUP_2: "Por padrão, o valor 0 (false) deverá ser definido na inicialização do dispositivo.",
  ACD_STATUS_POPUP_3: "Se ACD for suportado, e estiver ligado, então o valor será definido como 1 (true) sempre que um conflito de endereço for detectado.",

  ANNOUNCE_BASED_RING_NODE_POPUP_1: "O valor 'Sim' indica que a implementação ring node do dispositivo é baseada no processamento de Announce frames.",
  ANNOUNCE_BASED_RING_NODE_POPUP_2: "O valor 'Não' indica que a implementação não é baseada no processamento de Announce frames.",
  ANNOUNCE_BASED_RING_NODE_POPUP_3: "O valor 'Sem resposta' indica que não foi possível determinar o valor dessa flag.",

  BEACON_BASED_RING_NODE_POPUP_1: "O valor 'Sim' indica que a implementação ring node do dispositivo é baseada no processamento de Beacon frames.",
  BEACON_BASED_RING_NODE_POPUP_2: "O valor 'Não' indica que a implementação não é baseada no processamento de Beacon frames.",
  BEACON_BASED_RING_NODE_POPUP_3: "O valor 'Sem resposta' indica que não foi possível determinar o valor dessa flag.",

  FLUSH_TABLE_CAPABLE_POPUP_1: "O valor 'Sim' indica que o dispositivo é capaz de processar Flush_Table frames.",
  FLUSH_TABLE_CAPABLE_POPUP_2: "O valor 'Não' indica que o dispositivo não é capaz de processar Flush_Table frames.",
  FLUSH_TABLE_CAPABLE_POPUP_3: "O valor 'Sem resposta' indica que não foi possível determinar o valor dessa flag.",

  REDUNDANT_GATEWAY_CAPABLE_POPUP_1: "O valor 'Sim' indica que o dispositivo é capaz de fornecer a função de gateway redundante.",
  REDUNDANT_GATEWAY_CAPABLE_POPUP_2: "O valor 'Não' indica que o dispositivo não é capaz de fornecer a função de gateway redundante.",
  REDUNDANT_GATEWAY_CAPABLE_POPUP_3: "O valor 'Sem resposta' indica que não foi possível determinar o valor dessa flag.",

  SUPERVISOR_CAPABLE_POPUP_1: "O valor 'Sim' indica que o dispositivo é capaz de fornecer a função de supervisor.",
  SUPERVISOR_CAPABLE_POPUP_2: "O valor 'Não' indica que o dispositivo não é capaz de fornecer a função de supervisor.",
  SUPERVISOR_CAPABLE_POPUP_3: "O valor 'Sem resposta' indica que não foi possível determinar o valor dessa flag.",

  //  ---------------------------- TOPOLOGY ----------------------------
  TOPOLOGY_POPUP_1: "Alguns dispositivos nesta tela podem aparecer sem portas. Isso geralmente ocorre quando:",
  TOPOLOGY_POPUP_2: "O dispositivo não responde perguntas SNMP, ou;",
  TOPOLOGY_POPUP_3: "O dispositivo está com o SNMP desativado.",

  SNMP_POPUP_1: "Esta coluna informa quais dispositivos respondem perguntas SNMP, podendo assumir dois valores:",
  SNMP_POPUP_2: "Caso o dispositivo responda perguntas SNMP;",
  SNMP_POPUP_3: "Caso o dispositivo não responda perguntas SNMP.",

  //  ---------------------------- Media Counters ----------------------------

  ALIGNMENT_ERRORS_1: "Alignment",
  ALIGNMENT_ERRORS_2: "Errors",

  CARRIER_SENSE_ERRORS_1: "Carrier",
  CARRIER_SENSE_ERRORS_2: "Sense Errors",

  FCS_ERRORS_1: "FCS",
  FCS_ERRORS_2: "Errors",

  SINGLE_COLLISIONS_1: "Single",
  SINGLE_COLLISIONS_2: "Collisions",

  MULTIPLE_COLLISIONS_1: "Multiple",
  MULTIPLE_COLLISIONS_2: "Collisions",

  LATE_COLLISIONS_1: "Late",
  LATE_COLLISIONS_2: "Collisions",

  EXCESSIVE_COLLISIONS_1: "Excessive",
  EXCESSIVE_COLLISIONS_2: "Collisions",

  SQE_TEST_ERRORS_1: "SQE",
  SQE_TEST_ERRORS_2: "Test",
  SQE_TEST_ERRORS_3: "Errors",

  DEFERRED_TRANSMISSION_1: "Deferred",
  DEFERRED_TRANSMISSION_2: "Transmission",

  FRAME_TOO_LONG_1: "Frame",
  FRAME_TOO_LONG_2: "Too",
  FRAME_TOO_LONG_3: "Long",

  MAC_TRANSMIT_ERRORS_1: "MAC",
  MAC_TRANSMIT_ERRORS_2: "Transmit",
  MAC_TRANSMIT_ERRORS_3: "Errors",

  MAC_RECEIVE_ERRORS_1: "MAC",
  MAC_RECEIVE_ERRORS_2: "Receive",
  MAC_RECEIVE_ERRORS_3: "Errors",

  ALIGNMENT_ERRORS_POPUP: "Representa o número de frames recebidos que não terminam com um número par de octetos e possuem algum problema de CRC.",

  FCS_ERRORS_POPUP_1: "Representa o número de frames recebidos com checksum ruim (valor CRC) no frame Ethernet.",
  FCS_ERRORS_POPUP_2: "Esses frames são descartados e não se propagam para outras portas.",

  EXCESSIVE_COLLISIONS_POPUP_1: "O contador de colisões excessivas é incrementado após aconteceram 16 Late Collisions consecutivas em sequência.",
  EXCESSIVE_COLLISIONS_POPUP_2: "Após 16 tentativas de enviar o pacote, ele é descartado e o contador é incrementado.",

  DEFERRED_TRANSMISSION_POPUP_1: "Número total de frames cuja primeira tentativa de transmissão foi atrasada por conta do tráfego da rede.",
  DEFERRED_TRANSMISSION_POPUP_2: "Esse total inclui apenas os frames que são transmitidos subsequentemente sem erros e sem colisões.",

  LATE_COLLISION_POPUP_1: "Uma late collision ocorre quando dois dispositivos transmitem ao mesmo tempo, e nenhum dos dois lados da conexão detecta a colisão.",
  LATE_COLLISION_POPUP_2: "Isso ocorre, pois, o tempo de propagação o sinal de uma ponta da rede até a outra é maior que o tempo de colocar o pacote inteiro na rede. Os dois dispositivos que causam a late collision só descobrem que o outro está enviando após ter colocado o pacote inteiro na rede.",
  LATE_COLLISION_POPUP_3: "Late collisions não são detectadas pelo transmissor antes do primeiros slot de 64 bytes. Isto ocorre porque elas são detectadas apenas em transmissões de pacotes maiores que 64 bytes.",

  FRAME_TOO_LONG_POPUP: "O número de pacotes de entrada que excedem o tamanho máximo do pacote Ethernet.",

  MAC_TRANSMIT_ERRORS_POPUP: "Frames para os quais a transmissão falha devido à um erro de transmissão interno da subcamada MAC.",
  MAC_RECEIVE_ERRORS_POPUP: "Frames para os quais a recepção na interface Ethernet falhou devido a um erro de recebimento interno da subcamada MAC.",

  IMPORTARNT_DP: "IMPORTANTE: ",
  SQE_TEST_ERRORS_POPUP_1: "Um teste para detectar colisões presentes no circuito entre o transciever e o cartão de interface de rede (NIC - Network interface card).",
  SQE_TEST_ERRORS_POPUP_2: "Por conta de a maior parte dos NICs hoje em dia possuírem um transciever integrado, o teste de SQE é desnecessário.",
  SQE_TEST_ERRORS_POPUP_3: "Ignore esse media counter.",

  CARRIER_SENSE_ERRORS_POPUP: "Quantidade de vezes que a condição de carrier sense foi perdida ou nunca assegurada ao tentar transmitir um frame.",

  SINGLE_COLLISION_POPUP: "Número de pacotes de saída que sofreram apenas uma colisão durante a transmissão.",
  MULTIPLE_COLLISIONS_POPUP: "Número de pacotes de saída que sofreram mais de uma colisão durante a transmissão.",

  //  ---------------------------- Interface Counters ----------------------------
  INPUT: "Entrada",
  OUTPUT: "Saída",

  IN_OCTETS_1: "In",
  IN_OCTETS_2: "Octets",

  IN_UCAST_PACKETS_1: "In",
  IN_UCAST_PACKETS_2: "Ucast Packets",

  IN_NUCAST_PACKETS_1: "In",
  IN_NUCAST_PACKETS_2: "NUcast Packets",

  IN_DISCARDS_1: "In",
  IN_DISCARDS_2: "Discards",

  IN_ERRORS_1: "In",
  IN_ERRORS_2: "Errors",

  IN_UNKNOWN_PROTOS_1: "In",
  IN_UNKNOWN_PROTOS_2: "Unknown Protos",

  OUT_OCTETS_1: "Out",
  OUT_OCTETS_2: "Octets",

  OUT_UCAST_PACKETS_1: "Out",
  OUT_UCAST_PACKETS_2: "Ucast Packets",

  OUT_NUCAST_PACKETS_1: "Out",
  OUT_NUCAST_PACKETS_2: "NUcast Packets",

  OUT_DISCARDS_1: "Out",
  OUT_DISCARDS_2: "Discards",

  OUT_ERRORS_1: "Out",
  OUT_ERRORS_2: "Errors",

  IN_OCTETS_POPUP: "Número total de octetos recebidos na interface.",
  IN_UCAST_POPUP: "Número de pacotes unicast entregues a um protocolo de camada superior.",
  IN_NUCAST_POPUP: "Número de pacotes não unicast (Broadcast ou multicast) entregues a um protocolo de camada superior.",
  IN_DISCARDS_POPUP: "Número total de frames na entrada cuja tentativa de transmissão foi abandonada devido a recursos insuficientes.",
  IN_ERRORS_POPUP: "Número de pacotes de entrada que continham erros que os impediam de serem entregues a um protocolo de camada superior.",
  IN_UNKNOWN_PROTOS_POPUP: "Número de pacotes recebidos por meio da interface que foram descartados devido a um protocolo desconhecido ou não suportado.",

  OUT_OCTETS_POPUP: "O número total de octetos transmitidos para fora da interface.",
  OUT_UCAST_POPUP: "O número total de pacotes que os protocolos de nível superior solicitaram para serem transmitidos a um endereço unicast de sub-rede, incluindo aqueles que foram descartados ou não enviados.",
  OUT_NUCAST_POPUP: "O número total de pacotes que os protocolos de nível superior solicitaram para serem transmitidos para um endereço não unicast (broadcast ou multicast), incluindo aqueles que foram descartados ou não enviados.",
  OUT_DISCARDS_POPUP: "Número total de frames na saída cuja tentativa de transmissão foi abandonada devido a recursos insuficientes.",
  OUT_ERRORS_POPUP: "O número de pacotes de saída que não puderam ser transmitidos devido a erros.",

  //  ---------------------------- Log ----------------------------
  LOG_CSV_EXPORT_NAME: "Log.xlsx",
  LOG_CSV_HEADER: "Horário,IP,MAC,Nome do produto,Tipo,Evento\n",

  //  ---------------------------- Ping Graph ----------------------------
  DEVICES: "Dispositivos",
  DEVICES_TOOLTIP_1: "É possível visualizar no máximo 5 dispositivos ao mesmo tempo.",
  DEVICES_TOOLTIP_2: "Dispositivos com IP duplicado não são mostrados enquanto o problema não for solucionado.",
  TIME_DP: "Tempo: ",
  TIME: "Tempo",

  //  ---------------------------- Device Status ----------------------------

  // ---------------------------- Page Scaling Modifiers ----------------------------

  // ---------------------------- Configuration page related ----------------------------
  LOGIN_CREDENTIALS_FAILURE: "Ocorreu um erro ao realizar o login: Nome de usuário ou senha incorretos.",
  LOGIN_GENERAL_FALIURE: "Ocorreu um erro ao realizar o login:",
  LOGIN: "LOGIN",
  USERNAME: "Usuário",
  PASSWORD: "Senha",
  NEW_PASSWORD: "Nova senha",
  REPEAT_PASSWORD: "Repetir senha",
  ENTER: "Entrar",
  LOGOUT: "Logout",
  HOSTNAME: "Hostname",
  TIMEZONE: "Timezone",
  SOFTWARE_UPDATE: "Atualização de Software",
  CURRENT_VERSION: "Versão atual: ",
  REPORT: "Relatório",
  CHANGE_LOGIN: "Alterar login",
  CHANGE: "Alterar",
  UPDATE: "Atualizar",

  GPG_ALERT_MESSAGE: "Só é possível enviar arquivos com extensão .gpg",

  SEND_FILE_SUCCESS: "O arquivo foi enviado com sucesso.",
  SEND_FILES_SUCCESS: "Os arquivos foram enviados com sucesso.",
  SEND_FILE_SUCCESS_WARNING: "Não esqueça de verificar se a placa de rede do seu computador está na mesma subrede do IP: ",
  SEND_FILE_FAILURE: "Ocorreu um erro ao enviar o arquivo.",
  SEND_FILES_FAILURE: "Ocorreu um erro ao enviar os arquivos.",
  SEND_FILE_WAITING: "Enviando o arquivo.",
  SEND_FILES_WAITING: "Enviando os arquivos.",
  SEND_FILE_WRONG_FILENAME: "Nome inválido. O arquivo de atualização deve chamar-se: updateEthIP.tar.gz.gpg",
  SEND_FILE_CORRUPTED_FILE: "O arquivo de atualização foi corrompido durante o envio.",
  THE_FOLLOWING_FILES_COULD_NOT_BE_SENT: "Ocorreu um erro ao enviar os seguintes arquivos GSDML: ",
  THE_FOLLOWING_FILES_COULD_NOT_BE_REMOVED: "Ocorreu um erro ao remover os seguintes arquivos GSDML: ",
  SEND_CONFIG_SUCCESS: "As configurações foram enviadas com sucesso.",
  SEND_CONFIG_FAILURE: "Ocorreu um erro ao enviar as configurações.",
  SEND_CONFIG_WAITING: "Enviando as configurações.",
  SEND_CONFIG_WAITING_2: "Finalizando envio das configurações.",
  SEND_CONFIG_DONE: "Configurações enviadas.",
  START_MESSAGE_SUCCESS: "O monitor irá iniciar em 15 segundos.",
  START_MESSAGE_FAILURE: "Ocorreu um erro ao iniciar o monitor.",
  STOP_MESSAGE_SUCCESS: "O monitor irá parar em 15 segundos.",
  STOP_MESSAGE_FAILURE: "Ocorreu um erro ao parar o monitor.",
  WAITING: "Aguarde um instante",
  CLEAN_LOG_SUCCESS: "O log foi limpado com sucesso.",
  CLEAN_LOG_FAILURE: "Ocorreu um erro ao limpar o log.",

  CHANGE_USERNAME_SUCCESS: "O Nome de usuário foi alterado com sucesso. Por favor realize o login novamente.",
  CHANGE_USERNAME_FAILURE: "Ocorreu um erro ao alterar o nome de usuário: ",
  USERNAME_TOO_SHORT: "O nome de usuário precisa conter pelo menos um caractere.",
  PASSWORD_MISSMATCH: "As senhas digitadas não coincidem",
  CHANGE_PASSWORD_SUCCESS: "A senha foi alterada com sucesso. Por favor realize o login novamente.",
  CHANGE_PASSWORD_FAILURE: "Ocorreu um erro ao alterar a senha: ",

  VERIFY_THE_FOLLOWING_INFO: "Por favor verifique as seguintes informações:",
  INVALID_IP: "\n- O IP inserido é inválido",
  INVALID_SUBMASK: "\n- A máscara inserida é inválida",
  INVALID_GATEWAY: "\n- O gateway inserido é inválido",
  LOOPBACK_IP: "\n- O IP de loopback (127.0.0.1) não pode ser utilizado como IP do monitor",
  LOOPBACK_IP_NTP: "\n- O IP de loopback (127.0.0.1) não pode ser utilizado como IP do servidor NTP",
  TAG_TOO_LONG: "\n- O tamanho da tag não pode ultrapassar 30 caracteres",
  SELECT_TIMEZONE: "\n- É necessário selecionar uma Timezone para configurar o servidor NTP",
  SAME_SUBNET_IP_1: "\n- O endereço IP da interface office não pode estar na mesma subrede da interface ETHERNET.",
  SAME_SUBNET_IP_2: "\n- O endereço IP da interface ETHERNET não pode estar na mesma subrede da interface office.",
  SUBNET_OVERLAP_OFFICE: "\n- O TS Monitor EtherNet/IP detectou que existe sobreposição de endereços entre a subrede da interface ETHERNET e a subrede da interface office. Por esse motivo não é possível configurar a interface office com o endereço IP e máscara escolhidos.",
  SUBNET_OVERLAP_ETHERNET: "\n- O TS Monitor EtherNet/IP detectou que existe sobreposição de endereços entre a subrede da interface ETHERNET e a subrede da interface office. Por esse motivo não é possível configurar a interface ETHERNET com o endereço IP e máscara escolhidos.",
  SUBNET_OVERLAP_WLAN: "\n- O TS Monitor EtherNet/IP detectou que existe sobreposição de endereços entre a subrede da interface ETHERNET e a subrede da WLAN. Por esse motivo não é possível configurar a WLAN com o endereço IP e máscara escolhidos.",
  SUBNET_OVERLAP_ETHERNET_WLAN: "\n- O TS Monitor EtherNet/IP detectou que existe sobreposição de endereços entre a subrede da interface ETHERNET e a subrede da WLAN. Por esse motivo não é possível configurar a interface ETHERNET com o endereço IP e máscara escolhidos.",
  ZERO_IP_MSG: "\n- O IP 0.0.0.0 não pode ser utilizado como IP do monitor",
  ZERO_IP_MASK_MSG: "\n- O IP 0.0.0.0 não pode ser utilizado como máscara da rede",
  BROADCAST_IP_MSG: "\n- O IP de broadcast da rede não pode ser utilizado como IP do monitor",
  NETWORK_IP_MSG: "\n- O IP da rede não pode ser utilizado como IP do monitor",
  BROADCAST_GATEWAY_MSG: "\n- O IP de broadcast da rede não pode ser utilizado como IP do gateway",
  NETWORK_GATEWAY_MSG: "\n- O IP da rede não pode ser utilizado como IP do gateway",
 
  GENERATING_REPORT_WAITING: "Gerando relatório, por favor aguarde",

  ALTER_USERNAME: "ALTERAR USUÁRIO",
  ALTER_PASSWORD: "ALTERAR SENHA",

  SELECT_FILE: "Por favor selecione um arquivo para enviar",
  SELECT_AT_LEAST_ONE_FILE: "Por favor selecione ao menos um arquivo para enviar",
  SELECT_AT_LEAST_ONE_FILE_TO_DELETE: "Por favor selecione ao menos um arquivo para remover",

  DO_NOT_CLOSE_THIS_TAB: "Deixe esta aba aberta para acompanhar a atualização.",
  UPDATING_MONITOR_FILES: "Atualizando arquivos no monitor. Por favor aguarde.",
  MONITOR_FILES_UPDATED_SUCCESSFULLY: "Arquivos atualizados, preparando para reiniciar o monitor.",
  RESTARTING_MONITOR_WAIT: "Reiniciando o monitor, aguarde alguns minutos.",
  MONITOR_RESTART_SUCCESS: "O monitor foi reiniciado com sucesso.",
  MONITOR_RESTART_FAILURE: "Ocorreu um erro ao reiniciar o monitor.",
  UPDATE_SUCCESS: "A atualização foi realizada com sucesso!",
  UPDATE_ERROR_STRING: "Ocorreu o seguinte erro ao atualizar o monitor: ",

  // ------------------------------- NTP UPDATE STATUS ----------------------------

  NTP_INFO_TURNED_OFF_SUCCESS: "O servidor NTP foi desligado com sucesso.",
  NTP_INFO_TURNED_OFF_FAILURE: "Ocorreu um erro ao desligar o servidor NTP.",
  TURN_OFF_DATE: "\nHorário de desligamento: ",
  NTP_INFO_FAILURE: "Falha ao sincronizar com o servidor. Caso o erro persista entre em contato com o administrador do servidor NTP.",
  SEND_NTP_CONFIG_WAITING: "Enviando as configurações do servidor NTP.",
  SEND_NTP_CONFIG_DONE: "Configurações do servidor NTP enviadas.",

  PROCESSING_NTP_INIT: "Iniciando processamento das informações do servidor NTP.",
  PROCESSING_NTP_INFO: "Processando as informações do servidor NTP.",
  PROCESSED_NTP_INFO: "Informações do servidor NTP processadas.",
  PROCESSING_NTP_ERROR: "Ocorreu um erro ao enviar as informações para o servidor NTP. Verifique se o endereço IP do servidor está correto. Caso estiver, verifique também se o serviço de NTP está ligado e tente novamente.",

  ITS_NECESSARY_TO_DISABLE_THE_MONITORING_FIRST: "É necessário desligar o monitoramento primeiro antes de configurar a varredura.",
  MONITORING_QUESTION_ICON_INFO: "Liga e desliga o envio e captura de mensagens de forma ativa. Quando desligado, o monitor não dispara mensagens, e não obtém dados.",
  DEVICE_SEARCH_QUESTION_ICON_INFO: "Seleciona busca de forma contínua (constante) ou única, para diminuir o envio de mensagens. No modo de busca única novos dispositivos que surgirem na rede não serão encontrados.",
  GSDML_QUESTION_ICON_INFO: "O carregamento dos arquivos GSDml no TS Monitor amplia consideravelmente a capacidade de diagnóstico dos ativos, possibilitando a interpretação de informações específicas do fabricante que só podem ser mostradas caso o monitor tenha estes arquivos carregados.",


  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS: "Modifique pelo menos um dos campos para atualizar as configurações de interface.",
  TAG_WAS_CHANGED_SUCCESSFULLY: "A tag do monitor foi modificada com sucesso.",
  REMEMBER_TO_UPDATE_BROWSER_ADDRESS_TO: "\nLembre-se de atualizar o endereço no navegador para: ",
  UPDATE_INTERFACE_CONFIG_SUCCESS: "As configurações de interface foram atualizadas com sucesso!",

  CONTINUOUS: "Contínua",
  UNIQUE: "Única",

  ALTER_MONITOR_CONFIG: "Tem certeza que deseja alterar as configurações do monitor?",
  RESTART_SYSTEM: " Reiniciar Sistema",
  CONFIRM_RESTART_SYSTEM: "Tem certeza que deseja reiniciar o sistema?",
  RESTART_SYSTEM_FAILURE: "Ocorreu um erro ao tentar reiniciar o sistema.",
  RESTART_SYSTEM_SUCCESS: "Pedido de reinicialização enviado com sucesso. Aguarde cerca de 3 minutos para que o sistema seja reiniciado completamente.",

  PING_LIMIT: "Ping limite",
  ALTER_PING_LIMIT_SUCCESS: "O ping limite foi alterado com sucesso.",
  ALTER_PING_LIMIT_ERROR: "Ocorreu um erro ao alterar o ping limite.",

  PING_LIMIT_POPUP_1: "O ping limite é o valor de ping médio acima do qual é considerado que existe um problema com o dispositivo.",
  PING_LIMIT_POPUP_2: "A cada vez que um dispositivo ultrapassar esse valor um evento será registrado no TS Expert.",
  PING_LIMIT_POPUP_3: "A unidade de medida do ping é milissegundos (ms).",
  PING_LIMIT_POPUP_4: "O valor mínimo permitido para o ping limite é de 0 ms.",
  PING_LIMIT_POPUP_5: "O valor máximo permitido para o ping limite é de 10.000 ms (10 segundos).",

  PING_LIMIT_OUT_OF_BOUNDS: "O ping limite precisa estar entre 0 e 10.000 ms (10 segundos).",

  RATE: "Taxa",
  PACKET_LOSS_RATE: "Taxa limite de pings perdidos",
  PACKET_LOSS_POPUP: "A taxa limite de pings perdidos determina, para todos os dispositivos, a partir de qual porcentagem de pings perdidos o TS Expert registrará um evento.",

  ALTER_PACKET_LOSS_RATE_LIMIT_SUCCESS: "A taxa limite de pings perdidos foi alterada com sucesso.",
  ALTER_PACKET_LOSS_RATE_LIMIT_ERROR: "Ocorreu um erro ao alterar a taxa limite de pings perdidos.",
  PACKET_LOSS_RATE_LIMIT_OUT_OF_BOUNDS: "A taxa limite de pings perdidos precisa estar entre 0 e 100 (0-100%).",

  MEDIA_COUNTERS_INCREMENT: "Incremento de Media Counters",
  INTERFACE_COUNTERS_INCREMENT: "Incremento de Interface Counters",
  CLEAR: "Limpar",

  RESET_MEDIA_COUNTERS_INCREMENT_SUCCESS: "Os incrementos de Media Counters foram limpos (zerados) com sucesso.",
  RESET_MEDIA_COUNTERS_INCREMENT_FAILURE: "Ocorreu um erro ao zerar os incrementos de Media Counters.",

  RESET_INTERFACE_COUNTERS_INCREMENT_SUCCESS: "Os incrementos de Interface Counters foram limpos (zerados) com sucesso.",
  RESET_INTERFACE_COUNTERS_INCREMENT_FAILURE: "Ocorreu um erro ao zerar os incrementos de Interface Counters.",

  ETHERNET: "Ethernet",
  ETHERNET_POPUP_1: "Campo de configuração da interface Ethernet.",
  ETHERNET_POPUP_2: "Utilizado para supervisão e acesso Web aos dados do monitor.",

  WLAN: "WLAN",
  WLAN_POPUP_1: "Campo de configuração da interface sem fio, quando adaptador disponível.",
  WLAN_POPUP_2: "Utilizado para supervisão e acesso Web aos dados do monitor.",

  SETUP: "Configurar",

  SWEEP: "Varredura",
  SWEEP_POPUP_MSG: " Permite a configuração de varredura personalizada para até 5 subredes.",

  TAG_CONFIG: "Tag da rede",
  TAG: "Tag",
  TEST_NETWORK: "Rede de teste",
  TAG_CHANGE_FAILURE: "Ocorreu um erro ao modificar a tag do monitor.",
  REASON_DP: "Motivo: ",

  NTP_SERVER: "Servidor NTP",

  TURN_NTP_SERVER_ON: "Ligar servidor NTP",
  TURN_NTP_SERVER_ON_QUESTION: "Tem certeza que deseja ligar o servidor NTP? Para isso o monitor precisará ser reiniciado.",

  NTP_INFO_TURNED_ON_SUCCESS: "O servidor NTP foi ligado com sucesso.",
  NTP_INFO_TURNED_ON_FAILURE: "Ocorreu um erro ao ligar o servidor NTP.",
  TURN_ON_DATE: "\nO horário do servidor foi atualizado para: ",
  INTERFACE_CONFIG: "Configurações de Interface",
  INTERFACE_ETHERNET_CONFIG: "Configurações de Interface ETHERNET",
  // ---------------------------- WLAN Config ----------------------------
  ALTER_MONITOR_WLAN_CONFIG: "Tem certeza que deseja alterar as configurações de WLAN do monitor?",
  ALTER_OFFICE_INTERFACE_CONFIG_HEADER: "Configurar interface office",
  ALTER_OFFICE_INTERFACE_CONFIG: "Tem certeza que deseja alterar as configurações da interface office?",
  ALTER_OFFICE_INTERFACE_CONFIG_2: "Ao utilizar o modo DHCP tenha certeza de que a interface office não será configurada na mesma subrede que a interface ETHERNET, caso contrário o TS Monitor EtherNet/IP poderá apresentar comportamento fora do esperado.",

  CONNECTED: "Conectada",
  DISCONNECTED: "Desconectada",

  WLAN_STATUS_POPUP_1: "Indica o estado do adaptador WLAN do monitor.",
  WLAN_STATUS_POPUP_2: "Caso ele esteja desligado não é possível alterar as configurações WLAN.",

  CONNECTION_STATUS_POPUP_1: "Indica se o monitor está conectado ou não à rede WLAN configurada.",
  CONNECTION_STATUS_POPUP_1_1: "Indica se o monitor está conectado ou não à rede Ethernet configurada.",
  
  WLAN_CONFIG_POPUP_1: "Não é possível alterar as configurações enquanto o adaptador WLAN estiver desligado.",
  WLAN_CONFIG_POPUP_2: "É altamente recomendado que as configurações de WLAN sejam alteradas apenas ao acessar o monitor por meio da rede cabeada.",
  WLAN_CONFIG_POPUP_3: "Ao alterar o IP / máscara, caso os campos apareçam em branco após a atualização isso é um forte indicativo de que:",
  WLAN_CONFIG_POPUP_4: "Já existe um outro dispositivo na rede com o mesmo IP;",
  WLAN_CONFIG_POPUP_5: "A máscara de rede é muito restrita e não comporta o IP que foi passado.",

  ETHERNET_CONFIG_POPUP: "Campo de configuração da interface Ethernet conectada a rede industrial e utilizada pelo TS Monitor para captura de dados.",
  WLAN_CONFIG_POPUP: "Campo de configuração da interface sem fio, quando adaptador disponível, utilizada para supervisão e acesso Web aos dados do TS Monitor. Esta rede é isolada da rede Ethernet/Industrial.",
  OFFICE_CONFIG_POPUP: "Campo de configuração da interface Ethernet utilizada para supervisão e acesso Web aos dados do TS Monitor. Esta rede é isolada da rede Ethernet/Industrial.",
  BLACKLIST_CONFIG_POPUP: "Permite a exclusão de alguns serviços de coleta de dados do TS Monitor.",
  TS_EXPERT_CONFIG_POPUP: "Permite habilitar / desabilitar as não conformidades a serem informadas pela ferramenta.",

  WLAN_ADAPTER_NOT_FOUND_1: "O TS Monitor EtherNet/IP não conseguiu encontrar o adaptador WLAN:\n",
  WLAN_ADAPTER_NOT_FOUND_2: "  • Verifique se o adaptador está desconectado, ou com mal contato;\n",
  WLAN_ADAPTER_NOT_FOUND_3: "  • Caso o adaptador não esteja desconectado nem com mal contato, tente substituí-lo;\n",
  WLAN_ADAPTER_NOT_FOUND_4: "  • Se nenhuma das opções anteriores solucionar o problema entre em contato com a Toledo e Souza.",

  HOSTNAME_POPUP_1: "Um hostname deve possuir entre 2 e 64 caracteres para ser válido.",
  HOSTNAME_POPUP_2: "Além disso, ele pode conter apenas letras, números, pontos e hífens, e deve começar e terminar apenas com letras e números.",

  INVALID_HOSTNAME_1: "O hostname deve possuir entre 2 e 64 caracteres.",
  INVALID_HOSTNAME_2: "O hostname deve conter apenas letras, números, pontos e hífens, e deve começar e terminar apenas com letras e números.",

  HOSTNAME_CONFIG_SUCCESS: "O hostname foi configurado com sucesso.",
  HOSTNAME_CONFIG_ERROR: "Ocorreu um erro ao configurar o hostname",
  MODE: "Modo",
  HIDDEN_SSID: "SSID Oculto",
  OPTIONAL: " (Opcional)",
  FIXED_IP: "IP Fixo",

  TURNING_WLAN_OFF_WAITING: "Desligando o adaptador WLAN, por favor aguarde.",
  TURNING_WLAN_ON_WAITING: "Ligando o adaptador WLAN, por favor aguarde.",

  INVALID_DNS: "\n- O DNS inserido é inválido",
  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS_WLAN: "Modifique pelo menos um dos campos para atualizar as configurações WLAN.",
  UPDATE_WLAN_CONFIG_SUCCESS: "As configurações de WLAN foram atualizadas com sucesso!",
  UPDATE_OFFICE_INTERFACE_CONFIG_SUCCESS: "As configurações da interface office foram atualizadas com sucesso!",
  UPDATE_WLAN_CONFIG_ERROR: "Não foi possível conectar à rede WLAN. Caso o problema persista tente reiniciar o monitor ou o roteador WLAN.",
  UPDATE_OFFICE_INTERFACE_CONFIG_ERROR: "Erro ao configurar interface Office. Caso o problema persista tente reiniciar o monitor ou o roteador.",

  WLAN_STATUS: "Adaptador WLAN",
  WLAN_CONFIG: "Configurações WLAN",
  CONNECTION_STATUS: "Estado da conexão",

  WLAN_ADAPTER_ON: "Ligado",
  WLAN_ADAPTER_OFF: "Desligado",
  NETWORK_NAME_1: "Nome da rede",
  SEND_WLAN_CONFIG_WAITING: "Enviando as configurações, por favor aguarde. Isso pode levar cerca de um minuto.",
  LOADING_WAITING: "Carregando informações, por favor aguarde.",
  WLAN_INFO: "Informações WLAN",
  ETHERNET_OFFICE_INFO: "Informações ETHERNET Office",
  IP_PLACEHODLER: "192.168.2.220",
  SSID: "SSID",
  SSID_PLACEHOLDER: "SSID",
  MAC_PLACEHOLDER: "A0:8C:FD:19:DB:02",
  SIGNAL_STRENGTH: "Força do sinal",
  SIGNAL_STRENGTH_PLACEHOLDER: "90 dBm",
  FREQUENCY: "Frequência",
  FREQUENCY_PLACEHOLDER: "2.4GHz",
  CHANNEL: "Canal",
  QUALITY: "Qualidade",
  QUALITY_PLACEHOLDER: "Qualidade",
  SUBMASK: "Máscara",
  GATEWAY: "Gateway",
  MASK: "Máscara",
  ZERO_TRAFFIC: "0.00 Kbps",
  DNS: "DNS",

  ETHERNET_INTERFACE: "Interface ETHERNET",

  OFFICE_INTERFACE: "Interface OFFICE",

  // ---------------------------- Sweep Page ----------------------------
  PERSONALIZED_SWEEP: "Varredura personalizada",

  SWEEP_ON: "Ligada",
  SWEEP_OFF: "Desligada",
  BANDS: "Faixas",

  FIRST_BAND: "1ª Faixa",
  SECOND_BAND: "2ª Faixa",
  THIRD_BAND: "3ª Faixa",
  FOURTH_BAND: "4ª Faixa",
  FIFTH_BAND: "5ª Faixa",

  BEGINNING: "Início",
  END: "Fim",

  ALERT_MESSAGE_PLACEHOLDER: "Os campos das seguintes faixas possuem problemas: ",

  FIRST_SUBNETWORK_ADDRESS_NOT_VALID: "\n - O endereço da 1ª faixa não é valido",
  FIRST_SUBNETWORK_START_LESS_THAN_FINISH: "\n - O endereço de início da 1ª faixa é maior ou igual ao fim",
  FIRST_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - A 1ª faixa possui campos não preenchidos",

  SECOND_SUBNETWORK_ADDRESS_NOT_VALID: "\n - O endereço da 2ª faixa não é valido",
  SECOND_SUBNETWORK_START_LESS_THAN_FINISH: "\n - O endereço de início da 2ª faixa é maior ou igual ao fim",
  SECOND_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - A 2ª faixa possui campos não preenchidos",

  THIRD_SUBNETWORK_ADDRESS_NOT_VALID: "\n - O endereço da 3ª faixa não é valido",
  THIRD_SUBNETWORK_START_LESS_THAN_FINISH: "\n - O endereço de início da 3ª faixa é maior ou igual ao fim",
  THIRD_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - A 3ª faixa possui campos não preenchidos",

  FOURTH_SUBNETWORK_ADDRESS_NOT_VALID: "\n - O endereço da 4ª faixa não é valido",
  FOURTH_SUBNETWORK_START_LESS_THAN_FINISH: "\n - O endereço de início da 4ª faixa é maior ou igual ao fim",
  FOURTH_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - A 4ª faixa possui campos não preenchidos",

  FIFTH_SUBNETWORK_ADDRESS_NOT_VALID: "\n - O endereço da 5ª faixa não é valido",
  FIFTH_SUBNETWORK_START_LESS_THAN_FINISH: "\n - O endereço de início da 5ª faixa é maior ou igual ao fim",
  FIFTH_SUBNETWORK_HAS_UNFILLED_FIELDS: "\n - A 5ª faixa possui campos não preenchidos",

  SWEEP_DATA_SENT_SUCCESSFULLY: "As configurações de varredura foram salvas com sucesso.",
  SWEEP_DATA_SENT_ERROR: "Ocorreu um erro ao salvar as configurações de varredura.",
  SPECIFY_AT_LEAST_ONE_SUBNETWORK: "É preciso especificar ao menos uma subrede para salvar a varredura personalizada.",

  UNABLE_TO_SAVE_CUSTOM_SWEEP: "Não é possível salvar a varredura personalizada pois:",
  _THE: "- A ",
  BAND_HAS_IPS_NOT_IN_SUBNETWORK: "ª faixa contém IPs que não estão na subrede do monitor",
  SENDING_DATA: "Enviando dados",

  // ---------------------------- PDF Report ----------------------------

  CONFORM_STRING: "Conforme",
  CONFORM_W_RESTRICTION_STRING: "Conforme com restrições",
  NON_CONFORM_STRING: "Não conforme",

  GENERATING_REPORT_SUCCESS: "Relatório gerado com sucesso. Para salvá-lo, clique em salvar relatório abaixo.",

  CONFORMITY: "Conformidade",
  DROPDOWN_PLACEHOLDER: "Escolha uma opção",
  GENERATE_REPORT: "Gerar relatório",
  PING_GRAPHS: "Gráficos de ping",
  INCLUDE_IN_REPORT: "Incluir no relatório",
  CLIENT_INFO: "Informações do cliente",
  EXECUTING_COMPANY_INFO: "Informações da empresa executora",
  PROJECT_NAME_LABEL: "Nome do projeto",
  NETWORK_NAME_LABEL: "Nome da rede",
  LOCATION_LABEL: "Localização",
  COMPANY_NAME_LABEL: "Nome da empresa",
  ACCOUNTABLE_NAME_LABEL: "Nome do responsável",
  ADDRESS_LABEL: "Endereço",
  CITY_LABEL: "Cidade",
  PHONE_LABEL: "Telefone",
  EMAIL_LABEL: "E-mail",
  CLIENT_LOGO_LABEL: "Logo do cliente",
  EXECUTING_COMPANY_LOGO_LABEL: "Logo da empresa executora",
  ANNOTATIONS: "Anotações",
  CONCLUSION: "Conclusão",

  HEADER_TEXT: "Relatório de dados - TS Monitor EtherNet/IP",
  REPORT_EXPORT_NAME: "Relatório TS Monitor EtherNet/IP",

  GENERAL_REPORT: "Relatório geral – TS Monitor EtherNet/IP",
  DATA_REPORT: "Relatório de dados – TS Monitor EtherNet/IP",

  PROJECT_NAME: "- Nome do projeto:",
  NETWORK_NAME: "- Nome da rede:",
  LOCATION: "- Localização:",
  COMPANY_NAME: "- Nome da empresa:",
  ACCOUNTABLE_NAME: "- Nome do responsável:",
  COMPANY_ADDRESS: "- Endereço:",
  COMPANY_CITY: "- Cidade:",
  COMPANY_TEL: "- Telefone:",

  EXECUTING_COMPANY_NAME: "- Nome da empresa:",
  EXECUTING_ACCOUNTABLE_NAME: "- Nome do responsável:",
  EXECUTING_TEL: "- Telefone:",
  EXECUTING_EMAIL: "- Email:",

  MONITORING_INFO: "Informações do monitoramento",
  NETWORK_TAG_DP: "- Tag da rede: ",
  NETWORK_NAME_DP: "- Nome da rede: ",
  MONITOR_IP: "- IP do monitor: ",
  MONITOR_SUBMASK_DP: "- Máscara do monitor: ",
  GATEWAY_DP: "- Gateway: ",
  DNS_DP: "- DNS: ",
  MODO_DP: "- Modo de configuração: ",
  MONITOR_VERSION_DP: "- Versão do monitor: ",
  MONITOR_TIME_ON_DP: "- Tempo ligado: ",
  MEASUREMENT_INTERVAL_DP: "- Período de medição: ",
  REPORT_GENERATION: "- Relatório gerado em: ",
  NUM_OF_DEVICES_DP: "- Quantidade de dispositivos encontrados: ",
  NETWORK_AVAILABILITY_DP_2: "- Disponibilidade da rede: ",
  ETHERNET_INFO: "Informações ETHERNET",

  IP_DP: "- IP: ",
  MASK_DP: "- Máscara: ",

  SUMMARY: "Sumário",
  OVERVIEW: "Visão Geral",
  LIVE_LIST: "Live List",
  INVENTORY: "Inventário",
  PORTS: "Portas",
  NETWORK: "Rede",
  TOPOLOGY: "Topologia",
  MEDIA_COUNTERS: "Media Counters",
  INTERFACE_COUNTERS: "Interface Counters",
  LOG: "Log",
  PING_GRAPH: "Gráfico de ping",
  DISCLAIMER: "Aviso legal",

  OVERVIEW_DOTS: ".....................................................................................................................................",
  LIVE_LIST_DOTS: ".......................................................................................................................................",
  INVENTORY_DOTS: "....................................................................................................................................",
  PORTS_DOTS: "..........................................................................................................................................",
  NETWORK_DOTS: ".............................................................................................................................................",
  TOPOLOGY_DOTS: ".....................................................................................................................................",
  MEDIA_COUNTERS_DOTS: "............................................................................................................................",
  INTERFACE_COUNTERS_DOTS: ".......................................................................................................................",
  LOG_DOTS: "................................................................................................................................................",
  PING_GRAPH_DOTS: ".............................................................................................................................",
  DISCLAIMER_DOTS: "....................................................................................................................................",
  DISCLAIMER_DOTS_2: "..................................................................................................................................",

  OVERVIEW_PAGE_TITLE: "1. - Visão Geral",
  LIVE_LIST_PAGE_TITLE: "1. - Live List",
  INVENTORY_PAGE_TITLE: "2. - Inventário",
  PORTS_PAGE_TITLE: "3. - Portas",
  NETWORK_PAGE_TITLE: "4. - Rede",
  TOPOLOGY_PAGE_TITLE: "5. - Topologia",
  MEDIA_COUNTERS_PAGE_TITLE: "5. - Media Counters",
  INTERFACE_COUNTERS_PAGE_TITLE: "6. - Interface Counters",
  LOG_PAGE_TITLE: "7. - Log",
  PING_GRAPH_PAGE_TITLE: "8. - Gráfico de Ping",

  TS_MONITOR_VER_DP: "TS Monitor EtherNet/IP - Versão ",
  NETWORK_STATUS_DP: "Estado da rede: ",
  DEVICE_DATA: "Dados dos dispositivos",

  CONTROLLERS_DP: "Controladores: ",
  DEVICES_DP: "Dispositivos: ",
  SUPERVISORS_DP: "Supervisores: ",
  OTHER_DEVICES_DP: "Outros dispositivos: ",
  FAULTS_DP: "Falhas: ",
  ALARMS_DP: "Alarmes: ",
  IN_TRAFFIC_DP: "Tráfego ethernet de entrada: ",
  OUT_TRAFFIC_DP: "Tráfego ethernet de saída: ",

  MAC: "MAC",
  MACS: "MACs",
  IP: "IP",
  SNMP: "SNMP",
  NEIGHBOUR_PORT_1: "Porta",
  NEIGHBOUR_PORT_2: "vizinho",
  NEIGHBOUR_IP: "IP vizinho",

  DUPLICATE_IP_STRING: "IP duplicado",

  END_OF_REPORT: "Fim do relatório",
  DISCLAIMER_TEXT: "Os dados e valores apresentados neste relatório são meramente auxiliares para o especialista em EtherNet/IP, de tal sorte que qualquer indicação de correção deve ser feita pelo usuário. Por esta razão, recomenda-se acompanhamento de engenheiro certificado EtherNet/IP ou técnico responsável pela análise para atestar as informações prestadas pelo produto. Portanto a Toledo & Souza se exime de quaisquer responsabilidades, perdas ou danos, diretos ou indiretos causados pelas interpretações do software, não oferecendo nenhuma garantia em relação à integridade, qualidade ou adequação das informações prestadas, pois dependem da análise técnica de um profissional capacitado, sendo que na falta deste, o usuário assumirá o risco de que o conteúdo possa ser impreciso, incompleto ou possa não atender às suas necessidades e requisitos.",

  PROTOCOL: "Protocolo",
  CONFIG_METHOD: "Método de configuração",
  CURRENT_PING: "Ping atual",
  MEDIUM_PING: "Ping médio",
  LOST_PACKET_PERC: "Pings perdidos (%)",

  PRODUCT_NAME: "Nome do produto",
  PRODUCT_NAMES: "Nome dos produtos",
  VENDOR_ID: "Vendor ID",
  REVISION: "Revisão",
  PRODUCT_CODE: "Product Code",
  SERIAL_NUMBER: "Serial Number",
  DEVICE_TYPE: "Tipo de dispositivo",
  DEVICE_TYPE_1: "Tipo de",
  DEVICE_TYPE_2: "dispositivo",

  PRODUCT_NAME_N: "Nome\ndo\nproduto",
  INTERFACE_TYPE: "Tipo\nde\ninterface",
  DUPLEX_MODE: "Modo\nDuplex",
  INTERFACE_SPEED: "Velocidade\nda\ninterface",
  NEGOTIATION_STATUS: "Status\nde\nnegociação",
  HARDWARE_FAILURE: "Falha\nde\nhardware",
  INTERFACE_STATE: "Estado\nda\ninterface",
  LINK_STATUS: "Status\ndo\nlink",

  ACTIVE: "Ativo",
  INACTIVE: "Inativo",

  NETWORK_TOPOLOGY: "Topologia da rede",
  NETWORK_STATUS: "Status da Rede",
  ACD_CAPABLE: "ACD Capable",
  ACD_STATUS: "ACD Status",
  ANNOUNCE_BASED: "Announce-based Ring Node",
  BEACON_BASED: "Beacon-based Ring Node",
  FLUSH_TABLE_CAPABLE: "Flush Table Frame Capable",
  REDUNDANT_GATEWAY_CAPABLE: "Redundant\nGateway Capable",
  SUPERVISOR_CAPABLE: "Supervisor\nCapable",

  ALIGNMENET_ERRORS: "Alignment\nErrors",
  CARRIER_SENSE_ERRORS: "Carrier Sense Errors",
  FCS_ERRORS: "FCS\nErrors",
  SINGLE_COLLISIONS: "Single\nCollisions",
  MULTIPLE_COLLISIONS: "Multiple\nCollisions",
  LATE_COLLISIONS: "Late\nCollisions",
  EXCESSIVE_COLLISIONS: "Excessive Collisions",
  SQE_TEST_ERRORS: "SQE\nTest\nErrors",
  DEFERRED_TRANSMISSION: "Deferred Transmission",
  FRAME_TOO_LONG: "Frame\nToo\nLong",
  MAC_TRANSMIT_ERRORS: "MAC\nTransmit\nErrors",
  MAC_RECEIVE_ERRORS: "MAC\nReceive\nErrors",

  TRAFFIC_KBPS: "Tráfego (Kbps)",
  IN_OCTETS: "In\nOctets",
  IN_UCAST_PKTS: "In\nUcast\nPackets",
  IN_NUCAST_PKTS: "In\nNUcast\nPackets",
  IN_DISCARDS: "In\nDiscards",
  IN_ERRORS: "In\nErrors",
  IN_UNKNOWN_PROTOS: "In\nUnknown\nProtos",
  OUT_OCTETS: "Out\nOctets",
  OUT_UCAST_PKTS: "Out\nUcast\nPackets",
  OUT_NUCAST_PKTS: "Out\nNUcast\nPackets",
  OUT_DISCARDS: "Out\nDiscards",
  OUT_ERRORS: "Out\nErrors",

  // ---------------------------- OTHERS ----------------------------
  BEFORE_MONITOR_INIT_STR: "Anterior à última inicialização",
  REMOVE_DEVICE_SUCCESS: "O dispositivo será removido em até 30 segundos.",
  REMOVE_DEVICE_FAILURE: "Ocorreu um erro ao remover o dispositivo: ",
  OK_STRING: "OK",
  WITH_DIAGNOSTIC_STRING: "Com alarme",
  WITH_FAILURE_STRING: "Com falha",
  UNKNOWN: "Desconhecido",
  NO_EVENT: "Nenhum evento",
  LOG_WAITING: "Carregando dados do log",
  GO_TO_LOG_OR_REMOVE_POSITIONING: "Excluir device",
  ASK_DELETE_OR_LOG_1: "Deseja excluir da lista este device com IP duplicado?",
  ASK_DELETE_OR_LOG_2: "Deseja excluir da lista este device com possível perda de IP?",
  DELETE: "Excluir",
  GO_TO_LOG: " Ir para log",
  MEDIA_COUNTERS_PLACEHOLDER: "Filtrar por IP",

  LIVE_LIST_INPUT_TEXT_PLACEHOLDER: "Filtrar por IP, MAC ou protocolo",
  INVENTORY_INPUT_TEXT_PLACEHOLDER: "Filtrar por IP, MAC ou nome do produto",
  PORTS_INPUT_TEXT_PLACEHOLDER: "Filtrar por IP, MAC ou nome do produto",
  NETWORK_INPUT_TEXT_PLACEHOLDER: "Filtrar por IP, ou topologia da rede",

  TOPOLOGY_INPUT_TEXT_PLACEHOLDER: "Filtrar por IP ou MAC",
  TRAFFIC_INPUT_TEXT_PLACEHOLDER: "Filtrar por IP, nome ou modelo",
  LOG_INPUT_TEXT_PLACEHOLDER: "Filtrar IP, MAC, nome do produto ou tipo",
  GRAPHIC_TOPOLOGY_INPUT_PLACEHOLDER: "Pesquisar device por IP",
  FAULTS: "Falhas",
  STATISTICS: "Estatísticas",
  BILLIONS_OF: "Bilhões de",
  ONE_MILLION_OF: "Milhão de",
  ONE_BILLION_OF: "Bilhão de",
  MILLIONS_OF: "Milhões de",
  THOUSAND: "Mil",
  THOUSAND_NO_CAPITAL: " mil",
  MILLION_NO_CAPITAL: " milhão",
  MILLIONS_NO_CAPITAL: " milhões",
  BILLION_NO_CAPITAL: " bilhão",
  BILLIONS_NO_CAPITAL: " bilhões",
  LAST_EVENT: "Último evento: ",
  UP_TIME: "Tempo ligado:",
  MONITORING: "Monitoramento: ",
  TURNED_OFF: "Desligado ",
  TURNED_ON: "Ligado ",
  MONITORING_ON_TOOLTIP: "Serviço de monitoramento ligado.",
  MONITORING_OFF_TOOLTIP: "Serviço de monitoramento desligado. Para ligar o serviço acesse a janela MONITORAMENTO dentro da aba de Configurações.",
  MONITORING_GETTING_CONNECTION: "Estabelecendo conexão.",

  ALARMS_QUESTION_INFO: "Indica o número de alarmes respondidos pelos equipamentos. Alarmes indicam condições anormais de estado do dispositivo, como curto-circuito, problema de alimentação, falta de módulo, etc.",
  FAULTS_QUESTION_INFO: "Indica o número vezes que determinado equipamento EtherNet/IP não respondeu ao envio de mensagens pelo TS Monitor.",

  TYPE: "Tipo",
  DEVICE: "Dispositivo",

  // ---------------------------- GRAPH COLORS ----------------------------

  // ---------------------------- EXPERT ERROR TYPES ----------------------------





  // ---------------------------- TS EXPERT ----------------------------
  TS_EXPERT_REPORT_EXPORT_NAME: "Lista de ações - TS Expert - EtherNet/IP",

  TS_EXPERT_POPUP_1: "Nesta aba são apresentadas as informações do TS Expert.",
  TS_EXPERT_POPUP_2: "Esta ferramenta é um sistema especialista desenvolvido para otimizar e acelerar a análise das principais divergências detectadas pelo TS Monitor em redes EtherNet/IP.",
  TS_EXPERT_POPUP_3: "De forma automatizada, a manutenção, engenharia e equipes relacionadas podem obter uma lista de ações com diferentes eventos, suas possíveis causas, sugestões de solução e os dispositivos nos quais foram detectados.",
  TS_EXPERT_POPUP_4: "O uso do TS Expert não exclui a necessidade da análise humana e tampouco substitui tais capacidades de criar correlações de dados e interpretação.",

  TS_EXPERT: "TS Expert",
  EVENTS_LIST: "Lista de eventos",
  DETECTED_ON: "Detectado em: ",
  INCREMENT_DETECTED_ON: "Incremento mais recente detectado em: ",
  EXPORT_ACTIONS_LIST: "Exportar lista de ações",
  GENERATING_TS_EXPERT_REPORT_SUCCESS: "Relatório gerado com sucesso. Para salvá-lo, clique em salvar relatório.",

  ACTIONS: "Ações",

  NO_PROBLEM_DETECTED: "O TS Expert não detectou nenhum problema na rede.",
  NO_EVENTS_TO_BE_ANALYZED: "Não existem eventos a serem analisados.",

  NO_EVENT_SELECTED: "Nenhum evento selecionado",
  CHOOSE_AN_EVENT: "Escolha um evento para visualizar as ações sugeridas.",

  DETAILING: "Detalhamento",

  CHECKED: "Conferido",
  BATCH_CHECK: "Conferir todos",

  PROBLEM_CHECKED: "O evento foi conferido com sucesso",
  PROBLEM_CHECK_ERROR: "Ocorreu um erro ao conferir o evento.",

  QUANTITY_DP: "Quantidade: ",

  DEVICE_HAS_MEDIA_COUNTERS_PROBLEMS: "O dispositivo possui incrementos de media counters nas seguintes portas:",
  DEVICE_HAS_INTERFACE_COUNTERS_PROBLEMS: "O dispositivo possui incrementos de interface counters nas seguintes portas:",

  PORT_IS_STILL_INACTIVE: "A porta ainda está inativa",
  MARK_PROBLEM_AS_SOLVED: "Tem certeza que deseja marcar o evento como conferido?",

  LAST_UPDATED: "Atualizado pela última vez em: ",
  THIS_COMPUTER_TIME: " (Horário deste computador)",

  // ------------------------------ PING LIMIT ------------------------------
  GROUP_PING_LIMIT_HEADER: "Existem dispositivos na rede que excederam o valor limite de ping.",
  THE_LIMIT_VALUE_IS: "O valor limite é de: ",

  PING_LIMIT_EXCEEDED: "Limite de ping excedido",

  PING_LIMIT_HEADER_1: "O dispositivo de IP ",
  PING_LIMIT_HEADER_2: " excedeu o limite de ping.",

  PING_LIMIT_DESCRIPTION_1: "IP: ",
  PING_LIMIT_DESCRIPTION_2: "MAC: ",
  PING_LIMIT_DESCRIPTION_3: "Nome do produto: ",
  PING_LIMIT_DESCRIPTION_4: "Ping registrado: ",

  PING_LIMIT_SUGGESTION_1: "Quando um dispositivo exceder o valor limite de ping sugere-se:",
  PING_LIMIT_SUGGESTION_2: "Problemas de tráfego:",
  PING_LIMIT_SUGGESTION_3: "Utilizar a aba de Interface Counters e revisar as aplicações que estão utilizando o link, veja se estão de acordo com a infraestrutura disponível;",
  PING_LIMIT_SUGGESTION_4: "Verificar se a largura de banda disponível atende a aplicação (uso de switches Fast ou Gigabit Ethernet).",

  PING_LIMIT_SUGGESTION_5: "Alto uso de processamento de equipamentos e switches:",
  PING_LIMIT_SUGGESTION_6: "Revisar o consumo de dados da aplicação;",
  PING_LIMIT_SUGGESTION_7: "Revisar a temperatura dos equipamentos.",

  PING_LIMIT_SUGGESTION_8: "Atraso na propagação (Comprimento excessivo de cabos):",
  PING_LIMIT_SUGGESTION_9: "Identificar o comprimento do cabo, visualmente quando gravado no cabo, ou utilizando testadores ou certificadores.",

  NO_DEVICE_EXCEEDED_PING_LIMIT: "Não existem dispositivos na rede que excederam o limite de ping",

  // ------------------------------ DUPLICATE IP ------------------------------
  GROUP_DUPLICATE_IP_LIST_HEADER: "Existem dispositivos na rede com IP duplicado.",
  GROUP_DUPLICATE_IP_LIST_DESCR: "Por favor verifique sua rede.",

  DEVICES_WITH_DUPLICATE_IP: "Dispositivos com IP duplicado",
  DUPLICATE_IP_CARD_DESC: "Os dispositivos abaixo estão utilizando o endereço de IP ",

  DUPLICATE_IP_SUGGESTION_1: "Quando existirem IPs duplicados na rede sugere-se:",
  DUPLICATE_IP_SUGGESTION_2: "Conferir os endereços físicos, MAC, para identificar os dispositivos que apresentam conflito de endereço IP e corrigir as configurações deste endereço.",
  NO_DEVICES_WITH_DUPLICATE_IPS: "Não existem dispositivos na rede com IPs duplicados",

  // ------------------------------ DHCP ------------------------------
  DHCP_LIST_HEADER: "Existem dispositivos na rede cujos IPs foram configurados por DHCP.",
  DHCP_LIST_DESCR: "Idealmente o método de configuração deve ser estático.",

  DHCP_CONFIG_METHOD: "Método de configuração DHCP",

  DHCP_SUGGESTION_1: "Quando o método de configuração de um dispostivo for DHCP sugere-se:",
  DHCP_SUGGESTION_2: "Verificar se está sendo feito uso de endereçamento via DHCP. Este não é recomendado para um ambiente industrial, uma vez que a maioria das aplicações utiliza endereços de IP fixos e a configuração automática pode gerar conflitos se não forem planejados com precisão. Por esta razão, sugere-se utilizar o método de configuração como IP fixo.",

  NO_DEVICES_CONFIGURED_BY_DHCP: "Não existem dispositivos na rede configurados por DHCP",

  // ------------------------------ PACKET LOSS ------------------------------
  GROUP_PACKET_LOSS_LIST_HEADER: "Existem dispositivos na rede com % de pings perdidos acima da taxa limite.",
  GROUP_PACKET_LOSS_LIST_DESCR: "Por favor verifique sua rede.",

  PACKET_LOSS_GREATER_ONE_PERCENT: "% de pings perdidos acima da taxa limite",
  PACKET_LOSS_DESCRIPTION: "Pings perdidos (%): ",

  PACKET_LOSS_SUGGESTION_1: "Quando a % de pings perdidos de um dispositivo estiver acima da taxa limite sugere-se:",
  PACKET_LOSS_SUGGESTION_2: "Verificar se o dispositivo alvo está devidamente energizado e instalado;",
  PACKET_LOSS_SUGGESTION_3: "Verificar a presença de interferência eletromagnética, caso seja intermitente ou com comportamento não linear;",
  PACKET_LOSS_SUGGESTION_4: "Realizar certificação e teste dos cabos para eliminar a hipótese de problemas de meio físico;",
  PACKET_LOSS_SUGGESTION_5: "Verificar  o tráfego do link que conecta os dispositivos;",
  PACKET_LOSS_SUGGESTION_6: "Verificar o uso de memória e CPU dos dispositivos;",
  PACKET_LOSS_SUGGESTION_7: "Verificar a temperatura dos dispositivos.",
  PACKET_LOSS_SUGGESTION_8: "Pacotes ping considerados perdidos são aqueles que foram enviados, porém não retornaram ao dispositivo que os enviou.",
  OBS: "OBS: ",

  NO_DEVICES_SURPASSED_PING_LOST_LIMIT: "Não existem dispositivos na rede que cuja % de pings perdidos ultrapassou a taxa limite",

  // ------------------------------ INACTIVE PORT ------------------------------
  INACTIVE_PORT_LIST_HEADER: "Existem dispositivos na rede cujas portas foram inativadas.",
  INACTIVE_PORT_LIST_DESCR: "Por favor verifique sua rede.",

  INACTIVE_PORT: "Porta inativada",
  PORT: "Porta",

  INACTIVE_PORT_SUGGESTION_1: "Quando uma porta for inativada sugere-se:",
  INACTIVE_PORT_SUGGESTION_2: "Verificar se o dispositivo conectado à extremidade do cabo está energizado;",
  INACTIVE_PORT_SUGGESTION_3: "Verificar se houve rompimento no cabo;",
  INACTIVE_PORT_SUGGESTION_4: "Verificar a configuração da porta, caso tenha sido desabilitada.",

  NO_DEVICES_WITH_INACTIVE_PORTS: "Não existem dispositivos na rede que possuam portas inativadas (estava ativa e passou a ficar inativa)",

  // ------------------------------ NOT IN AUTONEGOTIATION ------------------------------
  NOT_IN_AUTONEGOTIATION_LIST_HEADER: "Existem dispositivos na rede cuja autonegociação de alguma das portas falhou.",
  NOT_IN_AUTONEGOTIATION_LIST_DESCR: "Por favor verifique sua rede.",

  AUTONEGOTIATION_FAILED: "Autonegociação falhou",

  NOT_IN_AUTONEGOTIATION_SUGGESTION_1: "Quando a autonegociação de uma porta falhar sugere-se:",
  NOT_IN_AUTONEGOTIATION_SUGGESTION_2: "Verificar a condição do cabeamento (má montagem de conectores, cabos danificados ou rompidos, cabos e conectores de baixa qualidade ou cabeamento excessivamente longo para a categoria);",
  NOT_IN_AUTONEGOTIATION_SUGGESTION_3: "Verificar a configuração das portas de ambas as extremidades (é possível que alguma taxa de comunicação ou modo duplex tenha sido fixado e seja incompatível com as configurações da porta da outra extremidade);",
  NOT_IN_AUTONEGOTIATION_SUGGESTION_4: "Verificar se os hardwares são incompatíveis (diferentes implementações do padrão de autonegociação podem gerar incompatibilidade);",
  NOT_IN_AUTONEGOTIATION_SUGGESTION_5: "A autonegociação não é aplicada para links de fibra ótica.",

  NO_DEVICES_WITH_AUTONEGOTIATION_FAULT: "Não existem dispositivos na rede com portas cuja autonegociação falhou",

  // ------------------------------ NOT IN FULL DUPLEX ------------------------------
  NOT_IN_FULL_DUPLEX_LIST_HEADER: "Existem dispositivos na rede com portas não configuradas em modo Full Duplex.",
  NOT_IN_FULL_DUPLEX_LIST_DESCR: "Por favor verifique sua rede.",

  PORT_NOT_IN_FULL_DUPLEX: "Porta não configurada em modo Full Duplex",

  NOT_IN_FULL_DUPLEX_SUGGESTION_1: "Quando o modo duplex de uma porta não for Full Duplex sugere-se:",
  NOT_IN_FULL_DUPLEX_SUGGESTION_2: "Verificar se a configuração das portas está em auto ou forçada;",
  NOT_IN_FULL_DUPLEX_SUGGESTION_3: "Verificar a integridade do cabeamento.",
  NOT_IN_FULL_DUPLEX_SUGGESTION_4: "Utilizar Full Duplex permite maior uso de banda total (envio e recebimento) e menores tempos de resposta.",

  NO_DEVICES_WITHOUT_FULL_DUPLEX: "Não existem dispositivos na rede com portas cujo modo duplex não seja Full Duplex",

  // ------------------------------ INTERFACE SPEED ------------------------------
  INTERFACE_SPEED_LIST_HEADER: "Existem dispositivos na rede com portas de velocidade de interface < 100 Mbps.",
  INTERFACE_SPEED_LIST_DESCR: "Por favor verifique sua rede.",

  INTERFACE_SPEED_LESSER_THAN_100: "Velocidade da interface < 100 Mbps",

  INTERFACE_SPEED_SUGGESTION_1: "Quando a velocidade da interface de uma porta for < 100 Mbps:",
  INTERFACE_SPEED_SUGGESTION_2: "Ainda que a aplicação não demande banda maior que 10 Mbits, tráfegos eventuais de acessos esporádicos ou manutenções podem causar a perda de comunicação.",
  INTERFACE_SPEED_SUGGESTION_3: "Sugere-se utilizar ao menos 100 Mbps para links normais e 1 Gbps para anéis de redundância e links prioritários ou de alta demanda.",

  NO_DEVICES_WITH_SLOW_PORTS: "Não existem dispositivos na rede com portas cuja velocidade de interface seja < 100 Mbps",

  // ------------------------------ HARDWARE FAULT ------------------------------
  HARDWARE_FAULT_LIST_HEADER: "Existem dispositivos na rede que estão com falha de hardware local em alguma de suas portas.",
  HARDWARE_FAULT_LIST_DESCR: "Por favor verifique sua rede.",

  PORT_WITH_LOCAL_HARDWARE_FAULT: "Porta com falha de hardware local",

  HARDWARE_FAULT_SUGGESTION_1: "Quando uma porta tiver falha de harware local sugere-se:",
  HARDWARE_FAULT_SUGGESTION_2: "Substituir ou reparar o dispositivo, e trocar a porta utilizada.",

  NO_DEVICES_WITH_PORT_HARDWARE_FAULT: "Não existem dispositivos na rede com portas que possuam falha de hardware local",

  // ------------------------------ ADDR CONFLICT ------------------------------
  ADDR_CONFLICT_LIST_HEADER: "Existem dispositivos na rede que detectaram conflitos de endereço.",
  ADDR_CONFLICT_LIST_DESCR: "Por favor verifique sua rede.",

  ADDR_CONFLICT_DETECTED: "Conflito de endereço detectado",

  ADDR_CONFLICT_DETECTED_SUGGESTION_1: "Quando um dispositivo detectar conflito de endereço sugere-se:",
  ADDR_CONFLICT_DETECTED_SUGGESTION_2: "Conferir o endereço físico MAC do outro dispositivo com endereço em conflito e corrigir as configurações de endereço lógico IP.",

  NO_DEVICES_WITH_ADDR_CONFLICT_DETECTED: "Não existem dispositivos na rede com conflito de endereço",

  // ------------------------------ MEDIA COUNTERS ------------------------------
  MEDIA_COUNTERS_LIST_HEADER: "Existem dispositivos com incremento de media counters.",

  MEDIA_COUNTERS_HEADER: "Incremento de Media Counters",
  ALIGNMENT_ERROR_HEADER: "Incremento de Alignment Errors",
  CARRIER_SENSE_HEADER: "Incremento de Carrier Sense Errors",
  FCS_ERROR_HEADER: "Incremento de FCS Errors",
  SINGLE_COLLISION_HEADER: "Incremento de Single Collisions",
  MULTIPLE_COLLISIONS_HEADER: "Incremento de Multiple Collisions",
  LATE_COLLISIONS_HEADER: "Incremento de Late Collisions",
  EXCESSIVE_COLLISIONS_HEADER: "Incremento de Excessive Collisions",
  SQE_TEST_HEADER: "Incremento de SQE Test Errors",
  DEFERRED_TRANSMISSION_HEADER: "Incremento de Deferred Transmissions",
  FRAME_TOO_LONG_HEADER: "Incremento de Frame Too Long",
  MAC_TRANSMIT_HEADER: "Incremento de MAC Transmit Errors",
  MAC_RECEIVE_HEADER: "Incremento de MAC Receive Errors",
  MEDIA_COUNTERS_NOT_SUPPORTED: "O dispositivo não suporta acesso aos media counters",
  MEDIA_COUNTERS_NOT_ANSWERED_YET: "O dispositivo ainda não respondeu",

  MEDIA_COUNTERS_SUGGESTION_1: "Quando um dispositivo possuir incremento de Media Counters sugere-se:",
  MEDIA_COUNTERS_SUGGESTION_2: "Navegar até a aba de Media Counters e clicar no botão presente no canto superior direito da tela (conforme imagem abaixo) para baixar o PDF de sugestão de ações.",
  MEDIA_COUNTERS_SUGGESTION_3: "No documento são apresentadas as possíveis causas para o incremento de cada um dos tipos de Media Counters.",

  MEDIA_COUNTERS_SUGGESTION_4: "Clicar no botão abaixo para baixar o PDF de sugestões de ações. No documento são apresentadas as possíveis causas para o incremento de cada um dos tipos de Media Counters.",

  DEVS_WITH_MEDIA_COUNTERS_EXPLANATION_1: "Nesta lista são mostrados apenas os dispositivos e respectivas portas que possuem incremento em ao menos um tipo de contador de media counters.",
  DEVS_WITH_MEDIA_COUNTERS_EXPLANATION_2: "Os contadores que possuirem incremento estarão destacados com a cor laranja.",

  NO_DEVICES_WITH_MEDIA_COUNTERS_INCREMENT: "Não existem dispositivos na rede com incremento de media counters",

  // ------------------------------ INTERFACE COUNTERS ------------------------------
  ACTION_SUGGESTION: "Sugestões de ações",
  DEVICES_WITH_INTERFACE_COUNTERS_INCREMENT: "Dispositivos que possuem incrementos de interface counters",
  INTERFACE_COUNTERS_LIST_HEADER: "Existem dispositivos com incremento de interface counters.",

  INTERFACE_COUNTERS_HEADER: "Incremento de Interface Counters",
  IN_DISCARDS_HEADER: "Incremento de In Discards",
  IN_ERRORS_HEADER: "Incremento de In Errors",
  IN_UNKNOWN_PROTOS_HEADER: "Incremento de In Unknown Protos",
  OUT_DISCARDS_HEADER: "Incremento de Out Discards",
  OUT_ERRORS_HEADER: "Incremento de Out Errors",
  INTERFACE_COUNTERS_NOT_SUPPORTED: "O dispositivo não suporta acesso aos interface counters",
  INTERFACE_COUNTERS_NOT_ANSWERED_YET: "O dispositivo ainda não respondeu",

  INTERFACE_COUNTERS_SUGGESTION_1: "Quando um dispositivo possuir incremento de Interface Counters sugere-se:",
  INTERFACE_COUNTERS_SUGGESTION_2: "Navegar até a aba de Interface Counters e clicar no botão presente no canto superior direito da tela (conforme imagem abaixo) para baixar o PDF de sugestão de ações.",
  INTERFACE_COUNTERS_SUGGESTION_3: "No documento são apresentadas as possíveis causas para o incremento de cada um dos tipos de Interface Counters.",

  INTERFACE_COUNTERS_SUGGESTION_4: "Clicar no botão abaixo para baixar o PDF de sugestões de ações. No documento são apresentadas as possíveis causas para o incremento de cada um dos tipos de Interface Counters.",

  DEVS_WITH_INTERFACE_COUNTERS_EXPLANATION_1: "Nesta lista são mostrados apenas os dispositivos e respectivas portas que possuem incremento em ao menos um tipo de contador de interface counters.",
  DEVS_WITH_INTERFACE_COUNTERS_EXPLANATION_2: "Os contadores que possuirem incremento estarão destacados com a cor laranja.",

  NO_DEVICES_WITH_INTERFACE_COUNTERS_INCREMENT: "Não existem dispositivos na rede com incremento de interface counters",

  // ---------------------------- FAULTS ----------------------------
  FAULTS_LIST_HEADER: "Existem dispositivos em falha na rede.",
  FAULTS_LIST_DESCR: "Por favor verifique sua rede.",
  DEVICE_WITH_FAULT: "Dispositivo em falha",

  FAULT_SUGGESTION_1: "Quando um dispositivo estiver em falha sugere-se:",
  FAULT_SUGGESTION_2: "Verificar a alimentação do dispositivo;",
  FAULT_SUGGESTION_3: "Verificar se ele está conectado fisicamente à rede;",
  FAULT_SUGGESTION_4: "Verificar a integridade do cabo;",
  FAULT_SUGGESTION_5: "Verificar se o dispositivo perdeu seu endereço IP.",

  NO_DEVICE_WITH_FAULT: "Não existem dispositivos na rede com falhas",

  // ---------------------------- LOST IP ----------------------------
  LOST_IP_LIST_HEADER: "Existem dispositivos com possível perda de IP na rede.",
  LOST_IP_DESCR: "Por favor verifique sua rede.",
  DEVICE_WITH_LOST_IP: "Dispositivo com possível perda de IP",

  LOST_IP_SUGGESTION_1: "Quando um dispositivo apresentar possível perda de IP sugere-se:",
  LOST_IP_SUGGESTION_2: "Conferir os endereços físicos, MAC, para identificar os dispositivos que apresentam conflito de endereço IP e corrigir as configurações deste endereço.",

  // ---------------------------- EXPERT REPORT ----------------------------
  DUPLICATE_IP_PAGE_TITLE: ". - IP Duplicado",
  AVG_PING_EXCEEDED_PAGE_TITLE: ". - Ping limite excedido",
  DHCP_CONFIG_METHOD_PAGE_TITLE: ". - Método de configuração DHCP",
  PACKET_LOSS_GREATER_ONE_PERCENT_PAGE_TITLE: ". - % de pings perdidos acima da taxa limite",
  INACTIVE_PORT_PAGE_TITLE: ". - Porta inativada",
  AUTONEGOTIATION_FAILED_PAGE_TITLE: ". - Auto negociação falhou",
  PORT_NOT_IN_FULL_DUPLEX_PAGE_TITLE: ". - Porta não configurada em modo Full Duplex",
  INTERFACE_SPEED_LESSER_THAN_100_PAGE_TITLE: ". - Velocidade da interface < 100 Mbps",
  PORT_WITH_LOCAL_HARDWARE_FAULT_PAGE_TITLE: ". - Porta com falha de hardware local",
  ADDR_CONFLICT_DETECTED_PAGE_TITLE: ". - Conflito de endereço detectado",
  TS_EXPERT_MEDIA_COUNTERS_PAGE_TITLE: ". - Media Counters",
  TS_EXPERT_INTERFACE_COUNTERS_PAGE_TITLE: ". - Interface Counters",
  FAULT_PAGE_TITLE: ". - Dispositivo com falha",
  LOST_IP_PAGE_TITLE: ". - Dispositivo com possível perda de IP",

  DUPLICATE_IP_DOTS: "..................................................................................................................................",
  AVG_PING_EXCEEDED_DOTS: ".....................................................................................................................",
  DHCP_CONFIG_METHOD_DOTS: "...................................................................................................",
  PACKET_LOSS_GREATER_ONE_PERCENT_DOTS: "...................................................................................",
  INACTIVE_PORT_DOTS: "..............................................................................................................................",
  AUTONEGOTIATION_FAILED_DOTS: "................................................................................................................",
  PORT_NOT_IN_FULL_DUPLEX_DOTS: "..............................................................................",
  INTERFACE_SPEED_LESSER_THAN_100_DOTS: "............................................................................................",
  PORT_WITH_LOCAL_HARDWARE_FAULT_DOTS: "...............................................................................................",
  ADDR_CONFLICT_DETECTED_DOTS: "..................................................................................................",
  TS_EXPERT_DISCLAIMER_DOTS: ".....................................................................................................................................",
  DEVICE_WITH_FAULT_DOTS: "....................................................................................................................",
  DEVICE_WITH_LOST_IP_DOTS: "......................................................................................... ",

  AVG_PING_EXCEEDED: "Ping limite excedido",
  REGISTERED_PING: "Ping registrado",

  // ---------------------------- LOG ----------------------------
  HORARY: "Horário",
  EVENT: "Evento",
  INSERT_VALID_LOG_INPUT: "Por favor, digite um IP, endereço MAC, nome do produto, ou tipo de evento válido",

  // ---------------------------- TS EXPERT CONFIG ----------------------------
  SAVE: "Salvar",
  SENDING_TS_EXPERT_CONFIG_WAITING: "Atualizando as configurações do TS Expert, aguarde um instante.",
  TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY: "As configurações do TS Expert foram salvas com sucesso.",
  TS_EXPERT_CONFIG_SAVE_ERROR: "Ocorreu um erro ao salvar as configurações do TS Expert.",

  TS_EXPERT_CONFIGURATION: "Configurações do TS Expert",

  CONFIG_DUPLICATE_IP_LIST_CONTENT: "Quando ativada esta opção, o TS Expert registrará todas as vezes que um IP duplicado for detectado na rede.",

  CONFIG_EXCEEDED_PING_LIST_HEADER: "Tempo de ping excedido",
  CONFIG_EXCEEDED_PING_LIST_CONTENT: "Quando ativada esta opção, o TS Expert registrará todas as vezes que o ping médio de um dispositivo exceder o valor de ping limite.",

  CONFIG_DHCP_LIST_HEADER: "DHCP",
  CONFIG_DHCP_LIST_CONTENT: "Quando ativada esta opção, o TS Expert registrará todas as vezes que o método de configuração de um dispositivo for DHCP.",

  CONFIG_LOST_PINGS_LIST_HEADER: "Pings perdidos",
  CONFIG_LOST_PINGS_LIST_CONTENT: "Quando ativada esta opção, o TS Expert registrará todas as vezes que a % de pings perdidos de um dispositivo for maior que a taxa limite.",

  CONFIG_INACTIVE_PORT_LIST_HEADER: "Porta inativada",
  CONFIG_INACTIVE_PORT_LIST_CONTENT: "Quando ativada esta opção, o TS Expert registrará todas as vezes que uma porta ativa de um dispositivo for inativada.",

  CONFIG_AUTO_NEGOTIATION_LIST_HEADER: "Porta com problema de auto-negociação",
  CONFIG_AUTO_NEGOTIATION_LIST_CONTENT: "Quando ativada esta opção, o TS Expert registrará todas as vezes que ocorrer um problema na auto-negociação de uma porta",

  CONFIG_DUPLEX_LIST_HEADER: "Porta não configurada em modo Full Duplex",
  CONFIG_DUPLEX_LIST_CONTENT: "Quando ativada esta opção, o TS Expert registrará todas as vezes que o modo duplex de uma porta não for Full Duplex.",

  CONFIG_SLOW_SPEED_LIST_HEADER: "Porta com velocidade da interface < 100 Mbps",
  CONFIG_SLOW_SPEED_LIST_CONTENT: "Quando ativada esta opção, o TS Expert registrará todas as vezes que a velocidade da interface de uma porta for < 100 Mbps.",

  CONFIG_LOCAL_HARDWARE_FAULT_LIST_HEADER: "Porta com falha de hardware local",
  CONFIG_LOCAL_HARDWARE_FAULT_LIST_CONTENT: "Quando ativada esta opção, o TS Expert registrará todas as vezes que uma porta possuir falha de hardware local.",

  CONFIG_ACD_LIST_HEADER: "ACD - Conflito de endereço",
  CONFIG_ACD_LIST_CONTENT: "Quando ativada está opção, o TS Expert registrará todas as vezes que um dispositivo detectar que houve um conflito de endereço.",

  CONFIG_MEDIA_COUNTERS_LIST_HEADER: "Media Counters",
  CONFIG_MEDIA_COUNTERS_LIST_CONTENT: "Quando ativada esta opção, o TS Expert registrará todas as vezes que um dispositivo possuir incremento no erro de algum contador da tela de Media Counters.",

  CONFIG_INTERFACE_COUNTERS_LIST_HEADER: "Interface Counters",
  CONFIG_INTERFACE_COUNTERS_LIST_CONTENT: "Quando ativada está opção, o TS Expert registrará todas as vezes que um dispositivo possuir incremento no erro de algum contador da tela de Interface Counters.",

  CONFIG_FAULTS_LIST_HEADER: "Falhas",
  CONFIG_FAULTS_LIST_CONTENT: "Se estiver ligado, o TS Expert irá registrar toda vez que um dispositivo Ethernet/IP entrar no status falha. Isso indica que ele não está respondendo a comandos ping e arp na rede, ou seja, não está acessível via rede.",

  CONFIG_LOST_IP_LIST_HEADER: "Perda de endereço IP",
  CONFIG_LOST_IP_LIST_CONTENT: "Se estiver ligado, o TS Expert irá registrar toda vez que for detectado um dispositivo com uma possível perda de endereço IP (0.0.0.0).",

  // ---------------------------- GRAPHIC TOPOLOGY ----------------------------
  EDIT_TOPOLOGY_POS_STRING: "Editar",
  SAVE_TOPOLOGY_POS_STRING: "Salvar",
  DELETE_TOPOLOGY_POS_STRING: "Remover",
  EXPORT_SVG: "SVG",

  EXPORT_TOPOLOGY: "Topologia",
  IMPORT: "Importar",
  IMPORT_TOPOLOGY: "Importar Topologia",
  POSITION: "Posição",
  EXPORT: "Exportar",

  SAVE_TOPOLOGY_POS_SUCCESS_STRING: "O posicionamento da topologia foi salvo com sucesso!",
  SAVE_TOPOLOGY_POS_FAILURE_STRING: "Ocorreu o seguinte erro ao salvar o posicionamento da topologia: ",

  DROP_TOPOLOGY_POS_SUCCESS_STRING: "O posicionamento da topologia foi removido com sucesso!",
  DROP_TOPOLOGY_POS_FAILURE_STRING: "Ocorreu o seguinte erro ao remover o posicionamento da topologia: ",

  ASK_REMOVE_POSITIONING: "Tem certeza que deseja remover o posicionamento salvo?",
  REMOVE_POSITIONING: "Remover posicionamento",

  YES: "Sim",
  NO: "Não",

  ALERT_NOT_POSSIBLE_TO_EDIT: "Não é possível editar dados do mestre",
  ALERT_NOT_POSSIBLE_TO_EDIT_SCOPE: "Não é possível editar os dados do TS Scope",
  ALERT_NOT_POSSIBLE_TO_DELETE: "Não é possível remover um device da live list",
  ALERT_CHOOSE_DEVICE_TYPE: "Por favor escolha um tipo de dispositivo",
  ALERT_CHOOSE_DEVICE_TYPE_ERROR: "Somente dispositivos EtherNet/IP podem ser editados",
  ALERT_CHOOSE_CONNECTION_TYPE: "Por favor selecione um tipo de conexão",

  ADD_DEVICE: "Adicionar dispositivo",
  TAG_PLACEHOLDER: "TAG (opcional)",

  DEVICE_DEFAULT_DROPDOWN_PLACEHOLDER: "Escolha um tipo de dispositivo",
  ADD_CONNECTION: "Adicionar conexão",
  CONNECTION_DEFAULT_DROPDOWN_PLACEHOLDER: "Escolha um tipo de conexão",
  EDIT_DEVICE: "Editar dispositivo",

  CANCEL: "Cancelar",
  ADD: "Adicionar",

  SCANNER_NAME: "Scanner",
  DEVICE_NAME_LABEL: "Nome: ",
  DEVICE_NAME: "Device",
  ACCESS_POINT_NAME: "Access Point",

  LOCALE_EDIT: "Editar",
  LOCALE_DEL: "Remover selecionado",
  LOCALE_BACK: "Voltar",
  LOCALE_ADD_NODE: "Adicionar dispositivo",
  LOCALE_ADD_EDGE: "Adicionar conexão",
  LOCALE_EDIT_NODE: "Editar dispositivo",
  LOCALE_EDIT_EDGE: "Editar conexão",
  LOCALE_ADD_DESCRIPTION: "Clique em um espaço em branco para adicionar um novo dispositivo",
  LOCALE_EDGE_DESCRIPTION: "Clique em um dispositivo e arraste a conexão até outro dispositivo para conectá-los",
  LOCALE_EDIT_EDGE_DESCRIPTION: "Clique nos pontos de controle e os arraste para um dispositivo para conectá-los",
  LOCALE_CREATE_EDGE_ERROR: "Não é possível criar conexão para um cluster",
  LOCALE_DELETE_CLUSTER_ERROR: "Clusters não podem ser removidos",
  LOCALE_EDIT_CLUSTER_ERROR: "Clusters não podem ser editados",

  FORM_NO_DEVICE_FOUND_PREFIX: "O dispositivo de endereço ",
  FORM_NO_DEVICE_FOUND_SUFFIX: " não foi encontrado",

  INSERT_VALID_ADDRESS_OR_TAG: "Favor digitar um endereço ou tag válidos",
  INSERT_VALID_ADDRESS0_TAG_OR_MODEL: "Favor digitar um endereço, tag ou modelo válidos",

  POSITIONING_CONFLICT_1: "Há um conflito nas informações dos dispositivos de endereços:",
  POSITIONING_CONFLICT_2: "\nPor conta disso, suas posições e conexões voltarão ao estado padrão.",
  POSITIONING_ANG_CONNECTIONS_RESET_SUCCESS: "Posicionamentos e conexões retornados ao estado padrão com sucesso",
  POSITIONING_ANG_CONNECTIONS_RESET_FAILURE: "Ocorreu o seguinte erro ao retornar os posicionamentos e conexões ao estado padrão: ",

  TOPOLOGY_IMPORT_SUCCESS: "A topologia foi importada com sucesso!",
  ERROR_IMPORTING_GRAPHIC_TOPOLOGY: "Ocorreu um erro ao importar a topologia gráfica: ",
  INVALID_OR_CORRUPT_FILE: "O arquivo não é válido ou está corrompido.",
  PLEASE_SELECT_TOPOLOGY_FILE: "Por favor selecione um arquivo de topologia.",

  COLORS_LABELS: "Legenda de cores e ícones",
  LABEL_DEVICE_OK: ": Dispositivo EtherNet/IP com status ok de comunicação;",
  LABEL_DEVICE_INCREMENT_ERROR: ": Dispositivo EtherNet/IP com incremento de erros. Consulte a tela de Interface Counters.",
  LABEL_DEVICE_FAULT: ": Dispositivo EtherNet/IP com falha de comunicação;",
  LABEL_NO_STATUS: ": Dispositivo sem status;",
  LABEL_DEVICE_ONLINE: ": Dispositivo online;",
  ADDRESS: "Endereço",
  MASTER_FAULT_STRING: "Scanner",
  DRIVE: "Drive",
  SWITCH: "Switch",

  INVALID_INSERTED_IP: "O IP inserido é inválido",

  FORM_INPUT_NOT_FOUND_1: "O device de IP: ",
  FORM_INPUT_NOT_FOUND_2: " não foi encontrado",
  FORM_INPUT_INVALID_IP: "Digite um endereço de ip valido",






  DUPLICATE_IPS: "Não foi possível carregar a topologia gráfica, pois a rede contém IPs duplicados.",


  // ---------------------------- MEDIA COUNTERS + INTERFACE COUNTERS REPORT ----------------------------
  GENERATING_ACTIONS_LIST_WAITING: "Gerando PDF de lista de ações, por favor aguarde.",
  GENERATING_ACTIONS_LIST_SUCCESS: "PDF gerado com sucesso. Para salvá-lo, clique em salvar lista de ações.",

  GENERATING_ACTIONS_SUGESTIONS_WAITING: "Gerando PDF de sugestões de ações, por favor aguarde.",
  GENERATING_ACTIONS_SUGGESTIONS_SUCCESS: "PDF gerado com sucesso. Para salvá-lo, clique em salvar sugestões de ações.",

  SUGGESTED_ACTIONS_HEADER_TEXT: "Sugestões de ações - Media / Interface Counters",

  COMMON_CAUSES: "Causas comuns: ",

  ALIGNMENT_ERRORS_DOTS: "..................................................................................................",
  CARRIER_SENSE_ERRORS_DOTS: ".............................................................................................",
  FCS_ERRORS_DOTS: ".............................................................................................................",
  SINGLE_COLLISIONS_DOTS: "...................................................................................................",
  MULTIPLE_COLLISIONS_DOTS: "................................................................................................",
  LATE_COLLISIONS_DOTS: "......................................................................................................",
  EXCESSIVE_COLLISIONS_DOTS: ".............................................................................................",
  DEFERRED_TRANSMISSIONS_DOTS: ".......................................................................................",
  FRAME_TOO_LONG_DOTS: "....................................................................................................",
  MAC_TRANSMIT_ERRORS_DOTS: "..........................................................................................",
  MAC_RECEIVE_ERRORS_DOTS: "............................................................................................",

  IN_DISCARDS_DOTS: "..........................................................................................................",
  IN_ERRORS_DOTS: "...............................................................................................................",
  IN_UNKNOWN_PROTOS_DOTS: ".............................................................................................",
  OUT_DISCARDS_DOTS: ".......................................................................................................",
  OUT_ERRORS_DOTS: "............................................................................................................",
  DEVS_WITH_INTERFACE_COUNTERS_DOTS: ".....................................................................",
  INTEFACE_COUNTERS_DISCLAIMER_DOTS: "....................................................................................................................................",

  ALIGNMENT_ERRORS_PAGE_TITLE: "1. - Incremento de Alignment Errors",
  CARRIER_SENSE_ERRORS_PAGE_TITLE: "2. - Incremento de Carrier Sense Errors",
  FCS_ERRORS_PAGE_TITLE: "3. - Incremento de FCS Errors",
  SINGLE_COLLISIONS_PAGE_TITLE: "4. - Incremento de Single Collisions",
  MULTIPLE_COLLISIONS_PAGE_TITLE: "5. - Incremento de Multiple Collisions",
  LATE_COLLISIONS_PAGE_TITLE: "6. - Incremento de Late Collisions",
  EXCESSIVE_COLLISIONS_PAGE_TITLE: "7. - Incremento de Excessive Collisions",
  DEFERRED_TRANSMISSIONS_PAGE_TITLE: "8. - Incremento de Deferred Transmissions",
  FRAME_TOO_LONG_PAGE_TITLE: "9. - Incremento de Frame Too Long",
  MAC_TRANSMIT_ERRORS_PAGE_TITLE: "10. - Incremento de MAC Transmit Errors",
  MAC_RECEIVE_ERRORS_PAGE_TITLE: "11. - Incremento de MAC Receive Errors",
  IN_DISCARDS_PAGE_TITLE: "12. - Incremento de In Discards",
  IN_ERRORS_PAGE_TITLE: "13. - Incremento de In Errors",
  IN_UNKNOWN_PROTOS_PAGE_TITLE: "14. - Incremento de In Unknown Protos",
  OUT_DISCARDS_PAGE_TITLE: "15. - Incremento de Out Discards",
  OUT_ERRORS_PAGE_TITLE: "16. - Incremento de Out Errors",

  ALIGNMENT_ERRORS_SUGGESTION_1: "Quando um dispositivo possuir incremento de Alignment Errors sugere-se:",
  ALIGNMENT_ERRORS_DP: "Alignment Errors: ",
  ALIGNMENT_ERRORS_SUGGESTION_2: "São pacotes recebidos sem um número par de octetos e com problemas de CRC.",
  ALIGNMENT_ERRORS_SUGGESTION_3: "Usualmente são resultado de incompatibilidade de Duplex ou problemas no meio físico como cabeamento, portas ou placa eletrônica de rede. Ao conectar cabos pela primeira vez este tipo de erro pode ocorrer.",

  CARRIER_SENSE_ERRORS_SUGGESTION_1: "Quando um dispositivo possuir incremento de Carrier Sense Errors sugere-se:",
  CARRIER_SENSE_DP: "Carrier Sense: ",
  CARRIER_SENSE_ERRORS_SUGGESTION_2: "O parâmetro incrementa cada vez que o controlador de rede Ethernet realizar a tentativa de enviar um pacote. A interface de rede “escuta” o meio físico e confere se não está sendo utilizado antes de enviar o pacote.",
  CARRIER_SENSE_ERRORS_SUGGESTION_3: "Estes eventos ocorrem em operação normal em links configurados como Half Duplex. Caso o link esteja configurado como Full Duplex indica problema no cabeamento ou na placa de rede interna ou na própria porta Ethernet.",

  FCS_ERRORS_SUGGESTION_1: "Quando um dispositivo possuir incremento de FCS Errors sugere-se:",
  FCS_ERRORS_DP: "FCS Errors (CRC incorreto): ",
  FCS_ERRORS_SUGGESTION_2: "Indica o número de vezes que um pacote com tamanho correto apresentou resultados diferentes do checksum enviado e o recebido.",
  FCS_ERRORS_SUGGESTION_3: "Usualmente indica problemas de meio físico como interferências, problemas no cabeamento ou nas interfaces de rede que interligam os equipamentos. Erros de CRC também podem ser originados por colisões e incompatibilidade de Duplex.",

  SINGLE_COLLISIONS_SUGGESTION_1: "Quando um dispositivo possuir incremento de Single Collisions sugere-se:",
  MULTIPLE_COLLISIONS_SUGGESTION_1: "Quando um dispositivo possuir incremento de Multiple Collisions sugere-se:",
  EXCESSIVE_COLLISIONS_SUGGESTION_1: "Quando um dispositivo possuir incremento de Excessive Collisions sugere-se:",

  SINGLE_MULTIPLE_EXCESSIVE_COLLISIONS_DP: "Single/Multiple/Excessive Collisions: ",
  SINGLE_MULTIPLE_EXCESSIVE_COLLISIONS_SUGGESTION_2: "indica o número de vezes que ocorreu uma/múltiplas/16 colisão(ões) antes do correto envio de um pacote.",
  SINGLE_MULTIPLE_EXCESSIVE_COLLISIONS_SUGGESTION_3: "Colisões são normais em links configurados em Half Duplex, porém não devem ocorrer em configuração Full Duplex. Se este parâmetro aumentar significativamente deve-se verificar se há alto uso de banda (tráfego excessivo), problema de montagem em cabeamento ou incompatibilidade de Duplex.",

  LATE_COLLISIONS_SUGGESTION_1: "Quando um dispositivo possuir incremento de Late Collisions sugere-se:",
  LATE_COLLISIONS_DP: "Late Collisions: ",
  LATE_COLLISIONS_SUGGESTION_2: "Indica o número de vezes que ocorreu uma colisão sem que os dispositivos tenham conseguido detectar a colisão por uma diferença de tempo.",
  LATE_COLLISIONS_SUGGESTION_3: "Cabeamentos com alterações elétricas e, mais comumente, excessivamente longos causam Late Collisions. Placas de rede com defeitos podem gerar aumento deste parâmetro ou incompatibilidade de Duplex.",

  DEFERRED_TRANSMISSIONS_SUGGESTION_1: "Quando um dispositivo possuir incremento de Deferred Transmissions sugere-se:",
  DEFERRED_TRANSMISSIONS_DP: "Deferred Transmissions: ",
  DEFERRED_TRANSMISSIONS_SUGGESTION_2: "Indica o número de vezes que um pacote foi enviado com atraso devido a tráfego na rede e não apresentaram erros ou colisões.",
  DEFERRED_TRANSMISSIONS_SUGGESTION_3: "Principalmente excesso de tráfego, sendo necessário ou reduzir o tráfego na porta que apresenta este erro ou reorganizar a topologia de rede.",

  FRAME_TOO_LONG_SUGGESTION_1: "Quando um dispositivo possuir incremento de Frame Too Long sugere-se:",
  FRAME_TOO_LONG_DP: "Frame too long: ",
  FRAME_TOO_LONG_SUGGESTION_2: "Indica o número de vezes que um pacote Ethernet excedeu o tamanho permitido.",
  FRAME_TOO_LONG_SUGGESTION_3: "Tamanho excessivo do pacote Ethernet ou número excessivo de informações como TAGs.",

  MAC_TRANSMIT_ERRORS_SUGGESTION_1: "Quando um dispositivo possuir incremento de Mac Transmit Error sugere-se:",
  MAC_TRANSMIT_ERROR_DP: "MAC Transmit Error: ",
  MAC_TRANSMIT_ERRORS_SUGGESTION_2: "Indica o número de vezes que um pacote cuja transmissão por uma interface apresentou um erro na subcamada MAC. São contabilizados apenas se os parâmetros late collisions, excessive collisions ou carrier sense não são contabilizados para determinado pacote.",
  MAC_TRANSMIT_ERRORS_SUGGESTION_3: "Possível problema de hardware na placa de rede.",

  MAC_RECEIVE_ERRORS_SUGGESTION_1: "Quando um dispositivo possuir incremento de Mac Receive Error sugere-se:",
  MAC_RECEIVE_ERROR_DP: "MAC Receive Error: ",
  MAC_RECEIVE_ERRORS_SUGGESTION_2: "Indica o número de vezes que um pacote cuja recepção por uma interface apresentou um erro na subcamada MAC. São contabilizados apenas se os parâmetros frame too long, alignment ou FCS Errors não são contabilizados para determinado pacote.",
  MAC_RECEIVE_ERRORS_SUGGESTION_3: "Possível problema de hardware na placa de rede.",

  IN_DISCARDS_SUGGESTION_1: "Quando um dispositivo possuir incremento de In Discards sugere-se:",
  IN_DISCARDS_SUGGESTION_2: "• Conferir o uso de banda na porta onde estão ocorrendo os descartes;",
  IN_DISCARDS_SUGGESTION_3: "• Verificar se há alto uso de memória e CPU nos gateways, switches e demais equipamentos. Usualmente estes pacotes são descartados para liberar espaço de buffers internos de equipamentos sobrecarregados;",
  IN_DISCARDS_SUGGESTION_4: "• Verificar configurações de controle de fluxo ou ACL (Address Control List);",
  IN_DISCARDS_SUGGESTION_5: "• Protocolos desconhecidos (em alguns casos) podem estar trafegando e não serem suportados;",
  IN_DISCARDS_SUGGESTION_6: "• Verificar se a porta está bloqueada por alteração na topologia pelo protocolo STP (Spanning Tree Protocol).",

  IN_ERRORS_SUGGESTION_1: "Quando um dispositivo possuir incremento de In Errors sugere-se:",
  IN_ERRORS_SUGGESTION_2: "• Verificar se há um problema de Duplex (uma porta 100 Mbps Full Duplex conectada a uma porta 10 Mbps Half Duplex). Os links devem ter a mesma configuração em ambas as extremidades e, preferencialmente, utilizar autonegociação;",
  IN_ERRORS_SUGGESTION_3: "• Conferir se as rotas dos cabos de dados em eletrocalhas, eletrodutos e bandejas estão próximas de cabeamento de potência, drives e demais equipamentos de maior consumo cujo cabeamento possa gerar interferência. Os cabos de rede devem estar o mais distante possível ou em eletrodutos isolados e aterrados;",
  IN_ERRORS_SUGGESTION_4: "• Verificar a qualidade dos links Ethernet. Conectores mal montados, cabos e conectores de baixa qualidade podem gerar perdas;",
  IN_ERRORS_SUGGESTION_5: "• Utilizando certificador, verificar se os cabos estão íntegros e com capacidade de desempenho para a categoria (Cat5, Cat5e, Cat6, etc.).",

  IN_UNKNOWN_PROTOS_SUGGESTION_1: "Quando um dispositivo possuir incremento de In Unknown Protos sugere-se:",
  IN_UNKNOWN_PROTOS_DP: "In Unknown Protos: ",
  IN_UNKNOWN_PROTOS_SUGGESTION_2: "Indica o número de pacotes com protocolo desconhecido recebido pelo equipamento. O incremento deste parâmetro indica a presença de tráfego de protocolo não conhecido na rede.",
  IN_UNKNOWN_PROTOS_SUGGESTION_3: "Buscar por equipamentos e softwares desconhecidos na rede e que possam estar realizando estes envios.",

  OUT_DISCARDS_SUGGESTION_1: "Quando um dispositivo possuir incremento de Out Discards sugere-se:",
  OUT_DISCARDS_SUGGESTION_2: "Verificar se há alto uso de memória e CPU nos gateways, switches e demais equipamentos. Usualmente estes pacotes são descartados para liberar espaço de buffers internos de equipamentos sobrecarregados.",

  OUT_ERRORS_SUGGESTION_1: "Quando um dispositivo possuir incremento de Out Errors sugere-se:",
  OUT_ERRORS_SUGGESTION_2: "• Verificar se há um problema de Duplex (uma porta 100 Mbps Full Duplex conectada a uma porta 10 Mbps Half Duplex). Links devem ter a mesma configuração em ambas as extremidades e, preferencialmente, utilizar autonegociação;",
  OUT_ERRORS_SUGGESTION_3: "• Verificar a qualidade dos links Ethernet. Conectores mal montados, cabos e conectores de baixa qualidade podem gerar perdas;",
  OUT_ERRORS_SUGGESTION_4: "• Verificar possíveis problemas na interface de rede do equipamento, sendo necessária sua substituição caso forem detectados.",

  MODEL: "Modelo",
  SUGGESTED_ACTIONS_BUTTON: "Sugestões de ações (PDF)",
  DESSELECT_ALL: "Desselecionar todos",
  SAVE_REPORT: "Salvar relatório",
  LESS_THAN_A_MINUTE: "< de 1 minuto",
  SUGGESTED_ACTIONS_FILENAME: "Sugestões de ações.pdf",
  FINISHING: "Finalizando...",
  SAVE_SUGGESTED_ACTIONS: "Salvar sugestões de ações",
  TS_EXPERT_REPORT_FILENAME: "Lista de ações - TS Expert - Ethernet_IP.pdf",
  SAVE_ACTIONS_LIST: "Salvar lista de ações",
  UNRESOLVED_PROBLEM_DUPLICATE_IP: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda estão com IP duplicado:\n",
  UNRESOLVED_PROBLEM_PING: "Não foi possível conferir os eventos dos seguintes dispositivos, pois os valores de ping médio continuam acima do valor configurado de limite de ping:\n",
  UNRESOLVED_PROBLEM_DHCP: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles continuam configurados por meio de DHCP:\n",
  UNRESOLVED_PROBLEM_PACKET_LOSS: "Não foi possível conferir os eventos dos seguintes dispositivos, pois a % de pings perdidos ainda é maior ou igual à taxa limite:\n",
  UNRESOLVED_PROBLEM_INACTIVE_PORT: "Não foi possível conferir os eventos dos seguintes dispositivos, pois suas portas continuam inativadas (estava ativa e passou a ficar inativa):\n",
  UNRESOLVED_PROBLEM_AUTONEGOTIATION: "Não foi possível conferir os eventos dos seguintes dispositivos, pois suas portas ainda acusam falha de autonegociação:\n",
  UNRESOLVED_PROBLEM_DUPLEX: "Não foi possível conferir os eventos dos seguintes dispositivos, pois suas portas não estão configuradas em modo Full Duplex:\n",
  UNRESOLVED_PROBLEM_INTERFACE_SPEED: "Não foi possível conferir os eventos dos seguintes dispositivos, pois a velocidade da interface das portas permanece < 100 Mbps:\n",
  UNRESOLVED_PROBLEM_HARDWARE_FAULT: "Não foi possível conferir os eventos dos seguintes dispositivos, pois suas portas ainda possuem falha de hardware local:\n",
  UNRESOLVED_PROBLEM_ADDRESS_CONFLICT: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda estão detectando um conflito de endereço:\n",
  UNRESOLVED_PROBLEM_RETRY: "Não foi possível conferir os eventos dos seguintes dispositivos, por favor tente novamente:\n",
  UNRESOLVED_PROBLEM_FAULT: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda se encontram em estado de falha:\n",
  UNRESOLVED_PROBLEM_LOST_IP: "Não foi possível conferir os eventos dos seguintes dispositivos, pois eles ainda apresentam possível perda de IP:\n",
  UNRESOLVED_PROBLEM_GENERIC: "Não foi possível conferir os eventos dos seguintes dispositivos:",
  TS_EXPERT_ERROR_DEVICE: "Dispositivo:\n",
  TS_EXPERT_ERROR_DUPLICATE_IP: "• IP duplicado: ",
  TS_EXPERT_ERROR_IP: "• IP: ",
  TS_EXPERT_ERROR_MAC: "• MAC: ",
  TS_EXPERT_ERROR_AVERAGE_PING: "• Ping médio: ",
  TS_EXPERT_ERROR_CONFIGURATION_METHOD: "• Método de configuração: ",
  TS_EXPERT_ERROR_LOST_PINGS: "• Pings perdidos (%): ",
  TS_EXPERT_ERROR_PORT: "• Porta: ",
  TS_EXPERT_ERROR_NEGOTIATION_STATUS: "• Status da negociação: ",
  TS_EXPERT_ERROR_DUPLEX_MODE: "• Modo duplex: ",
  TS_EXPERT_ERROR_INTERFACE_SPEED: "• Velocidade da interface: ",
  TS_EXPERT_ERROR_LOCAL_HARDWARE_FAULT: "• Falha de hardware local: ",
  TS_EXPERT_ERROR_ACD_STATUS: "• ACD Status: ",
  INVENTORY_MENU: "Inventário",
  PORTS_MENU: "Portas",
  NETWORK_MENU: "Rede",
  PING_GRAPH_MENU: "Gráfico de Ping",
  GRAPHIC_TOPOLOGY_MENU: "Topologia gráfica",
  CONFIGURATIONS_MENU: "Configurações",
  CHART_MONTHS: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
  CHART_SHORT_MONTHS: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
  CHART_DAYS: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
  CHART_SHORT_DAYS: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
  CHART_DOWNLOAD_SVG: "Baixar SVG",
  CHART_DOWNLOAD_PNG: "Baixar PNG",
  CHART_DOWNLOAD_CSV: "Baixar CSV",
  CHART_DOWNLOAD: "Baixar",
  CHART_SELECT: "Selecionar",
  CHART_SELECT_ZOOM: "Selecionar zoom",
  CHART_ZOOM_IN: "Aumentar",
  CHART_ZOOM_OUT: "Diminuir",
  CHART_PAN: "Navegação",
  CHART_RESET_ZOOM: "Reiniciar zoom",
  PING_MILLISECONDS: "Ping (ms)",
  BATCH_CHECK_SUCCESS: "Todos os eventos foram conferidos com sucesso.",
  REPORT_PAGE: "Página",
  REPORT_PDF_FILENAME: "Relatório TS Monitor EtherNet/IP.pdf",
  TS_EXPERT_REPORT_TITLE: "TS Expert:",
  TS_EXPERT_REPORT_ACTION_LIST: "Lista de ações",
  SUGGESTED_ACTIONS_REPORT_TITLE: "Sugestões de ações:",
  SUGGESTED_ACTIONS_REPORT_SUBTITLE: "Media Counters e Interface Counters",
  RELATIVE_YEAR: "ano",
  RELATIVE_MONTH: "mês",
  RELATIVE_MONTHS: "meses",
  RELATIVE_DAY: "dia",
  RELATIVE_HOUR: "hora",
  RELATIVE_MINUTE: "minuto",
  REPORT_LEGEND: "Legenda",
  REPORT_DUPLICATE_IP_LEGEND: "A célula IP de um dispositivo terá fundo roxo caso seu IP estiver duplicado.",
  REPORT_DHCP_LEGEND: "A célula Método de configuração terá o fundo azul escuro caso o método seja DHCP.",
});

export default Strings;
